import React, { useEffect, useState, useContext, useCallback, useRef } from 'react'
import Layout from '../Layout'
import SearchAuctionList from '../../../Component/Search/SearchAuctionList'
import ProductContext from '../../../Product/context/product/productContext'
import AuthContext from '../../../Product/context/auth/authContext'
import { useHistory, NavLink, Link } from 'react-router-dom'
import NoRecordsFound from '../../../Product/components/atoms/NoRecordsFound'
import './home.css'
import PrimaryButton from '../../../Product/components/atoms/PrimaryButton'
import { handleRedirectInternal, mapData } from '../../../Product/common/components'
import { Box, Button, ListItem, Tab, Tabs, Typography } from '@material-ui/core'
import PropTypes from 'prop-types'
import Loaders from '../../../Product/components/molecules/Loaders'
import jsonp from 'jsonp'
import AlertContext from '../../../Product/context/alert/alertContext'
import queryString from 'query-string'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/blur.css'
import GridProduct from '../../../Component/ProductCard/gridProduct'
import { messageHandler } from '../../../Product/common/socketHandler'
import { socket, socketAuction } from '../../../Product/common/socket'
import MultisellerSlider from '../../../Component/SlidePanel/MultisellerSlider'
import { makeStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import { Swiper, SwiperSlide, useSwiper, useSwiperSlide } from 'swiper/react/swiper-react'
import 'swiper/swiper-bundle.css'
import { EffectCoverflow, Navigation, Autoplay, Pagination } from 'swiper'
import Slider from 'react-slick'
import MultisellerListCard from '../../../Component/ProductCard/MultisellerListCard'
import ReactHtmlParser from 'react-html-parser'
import id from 'date-fns/locale/id'
const TabPanel = ({ children, value, index, ...other }) => {
    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </Typography>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

function a11yProps(index) {
    return {
        id: `home-auctions-${index}`,
        'aria-controls': `home-auctions-tabpanel-${index}`,
    }
}

const Home = (props) => {
    const { user } = useContext(AuthContext)
    const alertContext = useContext(AlertContext)
    const productContext = useContext(ProductContext)

    const {
        search_allauctions,
        getAllSearchAuctions,
        search_allproducts,
        getAllSearchProducts,
        productLocalState,
        clearResponse_search_details,
    } = productContext
    const { setAlert } = alertContext
    const sessionTimeOutRef = useRef(null)
    const authContext = useContext(AuthContext)
    const { isAuthenticated } = authContext
    const history = useHistory()
    const [loading, setLoading] = useState(true)
    const [loading_buynow, setLoadingBuynow] = useState(true)

    const [viewProduct, setViewProduct] = useState([])
    const [buyNowProduct, setBuyNowProduct] = useState([])
    const [selectedProduct, setSelectedProduct] = useState(null)
    const [value, setValue] = useState(0)
    const [inpData, setinpData] = useState('')
    const [filterValues, setFilterValues] = useState([])
    const [totalItems, setTotalItem] = useState(0)

    const [viewAuction, setViewAuction] = useState('')

    const viewProductRef = useRef(viewProduct)
    const userRef = useRef(user)

    useEffect(() => {
        viewProductRef.current = viewProduct
        userRef.current = user
    })

    const bodyClass = document.body.classList[1] == 'primeBids'

    const [auctionSearch, setAuctionSearch] = useState({
        page: 1,
        sh_limit: '10',
        orderby: '9',
        searchbar: '',
        auc_type: '2',
        type: '',
        auction_io: 1,
        auction_state:
            productLocalState.globalLocationFilter == 1
                ? []
                : productLocalState.globalLocationFilter == 2
                ? [productLocalState.globalLocation?.split(',')?.[1]?.trim()]
                : [productLocalState.globalLocation],
        auction_city:
            productLocalState.globalLocationFilter == 1
                ? [productLocalState.globalLocation]
                : productLocalState.globalLocationFilter == 2
                ? [productLocalState.globalLocation?.split(',')?.[0]?.trim()]
                : [],
    })

    const [subLotSearch, setSubLotSearch] = useState({
        auc_type: '2',
        page: 1,
        orderby: global?.storeConfigration?.home_pag_liq_2_changes?.value ? '11' : '2',
        lotof: '',
        sh_limit: 12,
        market_status: 'open',
        auction_io: 1,
        from: global?.storeConfigration?.home_pag_liq_2_changes?.value
            ? 'auction_only'
            : global.storeConfigration?.liq_home_page_changes?.value == 1
            ? undefined
            : 'auction_only',
        auction_state:
            productLocalState.globalLocationFilter == 1
                ? []
                : productLocalState.globalLocationFilter == 2
                ? [productLocalState.globalLocation?.split(',')?.[1]?.trim()]
                : [productLocalState.globalLocation],
        auction_city:
            productLocalState.globalLocationFilter == 1
                ? [productLocalState.globalLocation]
                : productLocalState.globalLocationFilter == 2
                ? [productLocalState.globalLocation?.split(',')?.[0]?.trim()]
                : [],
        type: 'active',
        need_bid_increment: 1,
    })

    const [buynowSearch, setBuynowSearch] = useState({
        sh_limit: 12,
        from: 'buynow',
        page: 1,
        orderby: '1',
        auction_io: 1,
        auction_state:
            productLocalState.globalLocationFilter == 1
                ? []
                : productLocalState.globalLocationFilter == 2
                ? [productLocalState.globalLocation?.split(',')?.[1]?.trim()]
                : [productLocalState.globalLocation],
        auction_city:
            productLocalState.globalLocationFilter == 1
                ? [productLocalState.globalLocation]
                : productLocalState.globalLocationFilter == 2
                ? [productLocalState.globalLocation?.split(',')?.[0]?.trim()]
                : [],
    })

    // useEffect(() => {
    //     if (value === 0 || value === 1) {
    //         setSubLotSearch({ ...subLotSearch, type: 'active', auc_type: '2' })
    //     }
    //     if (value === 2) {
    //         setBuynowSearch({ ...buynowSearch, type: 'active' })
    //     }
    // }, [value])

    useEffect(() => {
        if (search_allproducts.from === 'activeHome') {
            if (search_allproducts.results.length > 0) {
                search_allproducts.results.map((data) => {
                    if (data?.extra_fields?.includes('}')) {
                        let parse = JSON.parse(data.extra_fields)
                        Object.keys(parse).map((val) => {
                            data[val] = parse[val]
                        })
                    }
                })

                setViewProduct(search_allproducts.results.length ? search_allproducts.results : [])
            } else {
                setViewProduct([])
            }
            setLoading(false)
            setTotalItem(search_allproducts.total_pagecnt)
            clearTimeout(sessionTimeOutRef.current)
            clearResponse_search_details()
        } else if (search_allproducts.from === 'galleryPage') {
            if (search_allproducts.results.length > 0) {
                search_allproducts.results.map((data) => {
                    if (data?.extra_fields?.includes('}')) {
                        let parse = JSON.parse(data.extra_fields)
                        Object.keys(parse).map((val) => {
                            data[val] = parse[val]
                        })
                    }
                })
                setBuyNowProduct(
                    search_allproducts.results.length ? search_allproducts.results : [],
                )
            } else {
                setBuyNowProduct([])
            }
            setLoadingBuynow(false)
            setTotalItem(search_allproducts.total_pagecnt)
            clearResponse_search_details()
        }
    }, [search_allproducts])

    useEffect(() => {
        setLoadingBuynow(true)
        if (value === 2) {
            getAllSearchProducts(buynowSearch, 'galleryPage')
        }
    }, [buynowSearch])

    useEffect(() => {
        setLoading(true)
        getAllSearchProducts(subLotSearch, 'activeHome')
        sessionTimeOutRef.current = setTimeout(() => {
            if (!window.location.pathname.includes('/search')) {
                getAllSearchProducts(subLotSearch, 'activeHome')
            }
        }, 8000)
    }, [subLotSearch, isAuthenticated])

    useEffect(() => {
        if (productLocalState.globalLocationFilter == 1) {
            if (subLotSearch.auction_city != productLocalState.globalLocation) {
                setSubLotSearch({
                    ...subLotSearch,
                    auction_city: [productLocalState.globalLocation],
                })
                setBuynowSearch({
                    ...buynowSearch,
                    auction_city: [productLocalState.globalLocation],
                })
                setAuctionSearch({
                    ...auctionSearch,
                    auction_city: [productLocalState.globalLocation],
                })
            }
        } else if (productLocalState.globalLocationFilter == 2) {
            let city = productLocalState.globalLocation?.split(',')?.[0]?.trim()
            let state = productLocalState.globalLocation?.split(',')?.[1]?.trim()
            if (subLotSearch.auction_city != city || subLotSearch.auction_state != state) {
                setSubLotSearch({
                    ...subLotSearch,
                    auction_city: city,
                    auction_state: state,
                })
                setBuynowSearch({
                    ...buynowSearch,
                    auction_city: city,
                    auction_state: state,
                })
                setAuctionSearch({
                    ...auctionSearch,
                    auction_city: city,
                    auction_state: state,
                })
            }
        } else {
            if (subLotSearch.auction_state != productLocalState.globalLocation) {
                setSubLotSearch({
                    ...subLotSearch,
                    auction_state: [productLocalState.globalLocation],
                })
                setBuynowSearch({
                    ...buynowSearch,
                    auction_state: [productLocalState.globalLocation],
                })
                setAuctionSearch({
                    ...auctionSearch,
                    auction_state: [productLocalState.globalLocation],
                })
            }
        }
    }, [productLocalState.globalLocation])
    const handler = (message, type) => {
        messageHandler(
            message,
            viewProductRef.current,
            userRef.current,
            setAlert,
            setViewProduct,
            type,
        )
    }
    useEffect(() => {
        socket.on('realclosedupdates', (data) => {
            handler(data, 'realclosedupdates')
        })
        socket.on('bidAddtime', (data) => {
            handler(data, 'bidAddtime')
        })

        socket.on('buyer_assurance', (data) => {
            handler(data, 'buyer_assurance')
        })

        socketAuction.on('realclosedupdates', (data) => {
            handler(data, 'realclosedupdates')
        })
        socketAuction.on('bidAddtime', (data) => {
            handler(data, 'bidAddtime')
        })

        return () => {
            socket.off('realclosedupdates', (data) => {
                handler(data, 'realclosedupdates')
            })
            socket.off('bidAddtime', (data) => {
                handler(data, 'bidAddtime')
            })
            socket.off('buyer_assurance', (data) => {
                handler(data, 'buyer_assurance')
            })

            socketAuction.off('realclosedupdates', (data) => {
                handler(data, 'realclosedupdates')
            })
            socketAuction.off('bidAddtime', (data) => {
                handler(data, 'bidAddtime')
            })
        }
    }, [])

    useEffect(() => {
        setViewProduct([])
        setBuyNowProduct([])
        return () => {
            setViewProduct([])
            setBuyNowProduct([])
        }
    }, [])

    useEffect(() => {
        setFilterValues(
            global.searchCategories.sort((a, b) => a.description.localeCompare(b.description)),
        )
    }, [global.searchCategories])

    console.log(
        filterValues,
        global.searchCategories,
        typeof filterValues,
        'global.searchCategories',
    )

    const handleClose = () => setSelectedProduct(null)

    const handleClick = async (id) => {
        setSelectedProduct(id)
    }

    const handleChange = (event, newValue) => {
        setValue(newValue)
        if (newValue === 0 || newValue === 1) {
            if (global?.storeConfigration?.home_pag_liq_2_changes?.value) {
                setSubLotSearch({
                    ...subLotSearch,
                    type: 'active',
                    auc_type: '2',
                    most_viewed: undefined,
                    viewers: undefined,
                    featured: undefined,
                    orderby: newValue == 0 ? '11' : '',
                })
            } else {
                setSubLotSearch({
                    ...subLotSearch,
                    type: 'active',
                    auc_type: '2',
                    most_viewed: undefined,
                    viewers: undefined,
                    featured: undefined,
                })
            }

            //getAllSearchProducts({ ...subLotSearch, type: 'active', auc_type: '2' }, 'activeHome')
        }
        if (newValue === 3) {
            setSubLotSearch({
                ...subLotSearch,
                type: 'active',
                auc_type: '2',
                featured: 1,
                most_viewed: undefined,
                viewers: undefined,
            })
            //getAllSearchProducts({ ...subLotSearch, type: 'active', auc_type: '2' }, 'activeHome')
        }
        if (newValue === 4) {
            setSubLotSearch({
                ...subLotSearch,
                type: 'active',
                auc_type: '2',
                most_viewed: 1,
                viewers: 1,
                featured: undefined,
            })
            //getAllSearchProducts({ ...subLotSearch, type: 'active', auc_type: '2' }, 'activeHome')
        }
        if (newValue === 2) {
            if (global?.storeConfigration?.home_pag_liq_2_changes?.value) {
                handleRedirectInternal(history, 'how_it_works')
            } else {
                setBuynowSearch({ ...buynowSearch, type: 'active' })
                //getAllSearchProducts({ ...buynowSearch, type: 'active' }, 'galleryPage')
            }
        }
    }

    const [state, setState] = React.useState({
        bottom: false,
    })

    const toggleDrawer = (anchor, open) => (event) => {
        setState({ ...state, [anchor]: open })
    }

    useEffect(() => {
        getAllSearchAuctions(auctionSearch, 'home_page')
    }, [auctionSearch])

    useEffect(() => {
        if (search_allauctions.from == 'home_page') {
            setViewAuction(search_allauctions.results.length ? search_allauctions.results : [])
        } else {
            setViewAuction([])
        }
    }, [search_allauctions])

    const subscribe = () => {
        if (inpData) {
            if (!/\S+@\S+\.\S+/.test(inpData)) {
                return setAlert('Invalid email address', 'error')
            }

            const data = {
                EMAIL: inpData,
            }

            jsonp(
                `//${global.storeConfigration?.subscribe_code.value}${queryString.stringify(data)}`,
                { param: 'c' },
                (err, data) => {
                    //console.log('display', data.result)
                    if (err) {
                        return false
                    }
                    if (data.result === 'success') {
                        setinpData('')
                        return setAlert(data.msg, 'success')
                    }
                    if (data.result === 'error') {
                        return setAlert(data.msg, 'warning')
                    }
                },
            )
        }
        setinpData('')
    }

    const settings = {
        dots: false,
        fade: false,
        arrows: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        speed: 2000,
        autoplaySpeed: 10000,
        cssEase: 'linear',
    }

    const checkThemeClassName = document.body.className == 'liquidationTwo primeBids'
    const checkMediaWithPrimeBidTheme =
        window.matchMedia('(max-width:768px)').matches && checkThemeClassName

    return (
        <Layout props={props}>
            <div className="home">
                <div className="customContainer bannerContainer">
                    {global.multipleBannersFields.length ? (
                        <div className="siteBanner multiple">
                            {
                                <Slider {...settings}>
                                    {global.multipleBannersFields?.map((data, index) => (
                                        <>
                                            <img
                                                src={
                                                    process.env.REACT_APP_AUCTION_IMAGE_URL +
                                                    '/' +
                                                    data?.image_name
                                                }
                                            />
                                            <div className="bannerContent">
                                                <h2 className="pb-4">
                                                    {
                                                        JSON.parse(data.fields ? data.fields : '{}')
                                                            .title
                                                    }
                                                </h2>
                                                {/* <PrimaryButton
                                                    label={
                                                        isAuthenticated
                                                            ? JSON.parse(
                                                                  data.fields ? data.fields : '{}',
                                                              ).btn_text
                                                            : 'Sign Up'
                                                    }
                                                    type="button"
                                                    onClick={() =>
                                                        !isAuthenticated
                                                            ? handleRedirectInternal(
                                                                  history,
                                                                  'sign-up',
                                                              )
                                                            : (window.location.href = JSON.parse(
                                                                  global.multipleBannersFields[
                                                                      index
                                                                  ].fields
                                                                      ? global
                                                                            .multipleBannersFields[
                                                                            index
                                                                        ].fields
                                                                      : '{}',
                                                              ).btn_link)
                                                    }
                                                /> */}
                                            </div>
                                        </>
                                    ))}
                                </Slider>
                            }
                        </div>
                    ) : (
                        <div className="siteBanner">
                            <LazyLoadImage
                                src={global?.storeDetails?.bannerValue}
                                alt={`${global?.storeDetails?.name} banner`}
                                effect="blur"
                                height="100%"
                                width="100%"
                            />
                            <div className="bannerContent">
                                <h2>{global?.storeDetails?.description}</h2>
                                {/* <PrimaryButton
                                    label="Explore Now"
                                    onClick={() =>
                                        handleRedirectInternal(
                                            history,
                                            `${isAuthenticated ? 'search' : 'sign-up'}`,
                                        )
                                    }
                                /> */}
                            </div>
                        </div>
                    )}
                    {checkThemeClassName && (
                        <div className="PmCategoryBase-root">
                            {filterValues?.map((data, index) => (
                                <div
                                    className="PmCategoryList-root"
                                    key={index}
                                    onClick={() =>
                                        handleRedirectInternal(
                                            history,
                                            'search?q=&z=&m=&view=0&cat=' + data.id,
                                        )
                                    }
                                >
                                    <picture className="PmCategoryImage-root">
                                        <img
                                            className="PmCategoryImage lazy"
                                            src={
                                                data.image != 'noimg'
                                                    ? process.env.REACT_APP_PRODUCT_IMAGE_URL +
                                                      data.image
                                                    : process.env.REACT_APP_AUCTION_IMAGE_URL +
                                                      global?.storeDetails?.logo
                                            }
                                            data-src="image.jpg"
                                            alt={data.description_without_count}
                                        />
                                    </picture>
                                    <h4 className="PmCategoryTitle m-0">
                                        {data.description_without_count}
                                    </h4>
                                </div>
                            ))}
                        </div>
                    )}
                    {/* My auction house banner (Hidden for now, confirm with customer before removing completely)*/}
                    {/* {global?.storeDetails.site_id == 'AS0318' ||
                    global?.storeDetails.site_id == 'AS0354' ? (
                        <div className="siteBanner newBanner">
                            <div
                                className="bannerContent newBannerContent"
                                style={{ zIndex: '1000' }}
                            >
                                <h3>Welcome to Our New Website</h3>
                                <h5>
                                    During this transition we will be hosting auctions on both HiBid
                                    and this website for a week or two while we get YOUR feedback
                                    and work out any kinks!
                                    <br></br>
                                    Thanks for sticking with us and don&apos;t hesitate to reach out
                                    with any and all feedback or requests!
                                </h5>
                                <button
                                    className="newBannerButton"
                                    onClick={() =>
                                        window.open('https://myauctionhouse.hibid.com', '_blank')
                                    }
                                >
                                    VIEW HiBid AUCTIONS HERE
                                </button>
                            </div>
                        </div>
                    ) : null} */}
                </div>
                <div className="customContainer auctionListCnt">
                    <div className="appBarWrapper">
                        <AppBar position="static">
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                aria-label="simple tabs example"
                            >
                                <Tab
                                    label={
                                        global?.storeConfigration?.home_pag_liq_2_changes?.value
                                            ? 'TODAYS TOP DEALS'
                                            : 'TRENDING'
                                    }
                                    {...a11yProps(0)}
                                />
                                <Tab
                                    label={
                                        global?.storeConfigration?.home_pag_liq_2_changes?.value
                                            ? 'DEALS ENDING SOON'
                                            : 'ACTIVE LOTS'
                                    }
                                    {...a11yProps(1)}
                                />
                                {global?.storeConfigration?.home_pag_liq_2_changes?.value ? (
                                    <Tab label={'HOW IT WORKS'} {...a11yProps(2)} />
                                ) : (
                                    ''
                                )}
                                {productLocalState.disableBuynowLocations?.includes(
                                    productLocalState.globalLocation,
                                ) ||
                                global?.storeConfigration?.home_pag_liq_2_changes?.value ? null : (
                                    <Tab label="BUY NOW" {...a11yProps(2)} />
                                )}
                                {global?.storeConfigration?.enable_feature_lots?.value == 1 && (
                                    <Tab label="FEATURED LOTS" {...a11yProps(3)} />
                                )}
                                {global?.pluginConfiguration?.most_viewed?.enable == 1 && (
                                    <Tab label="MOST VIEWED" {...a11yProps(4)} />
                                )}
                                {checkThemeClassName ? (
                                    <Link className="seeAll" to="/search">
                                        SEE ALL DEAL
                                    </Link>
                                ) : (
                                    ''
                                )}
                            </Tabs>
                        </AppBar>
                    </div>
                    <TabPanel value={value} index={0}>
                        <>
                            {loading ? (
                                <div className="homeLoader">
                                    <Loaders
                                        name="product_grid_view"
                                        isLoading={loading}
                                        loop={5}
                                    />
                                </div>
                            ) : viewProduct.filter(
                                  (data) => data.market_status == 'open' && data.remainingDay >= 0,
                              ).length === 0 ? (
                                <NoRecordsFound />
                            ) : (
                                <div>
                                    <div className="mb-2 liquidationBuyCard">
                                        <Swiper
                                            navigation={true}
                                            spaceBetween={13}
                                            grabCursor={true}
                                            slidesPerView={4}
                                            slidesPerGroup={4}
                                            speed={2500}
                                            showsPagination={false}
                                            // pagination={{
                                            //     clickable: false,
                                            // }}
                                            autoplay={{
                                                delay: 2500,
                                                disableOnInteraction: false,
                                                pauseOnMouseEnter: true,
                                            }}
                                            breakpoints={{
                                                300: {
                                                    slidesPerGroup: 1,
                                                    slidesPerView: 1,
                                                },
                                                500: {
                                                    slidesPerView: 2,
                                                },
                                                900: {
                                                    slidesPerView: 3,
                                                },
                                                1260: {
                                                    slidesPerView: 4,
                                                },
                                                1400: {
                                                    slidesPerView: 5,
                                                },
                                            }}
                                            modules={[
                                                Autoplay,
                                                EffectCoverflow,
                                                Navigation,
                                                Pagination,
                                            ]}
                                            className="mySwiper"
                                        >
                                            {global?.storeConfigration?.homeTrendingView?.value ==
                                            1 ? (
                                                <>
                                                    {global.storeConfigration?.liq_home_page_changes
                                                        ?.value == 1 ? (
                                                        <>
                                                            {viewProduct?.map((data, index) => {
                                                                if (index < 15) {
                                                                    return (
                                                                        <SwiperSlide>
                                                                            <div className="">
                                                                                <GridProduct
                                                                                    data={data}
                                                                                    className={
                                                                                        data.auction
                                                                                            ? 'auction'
                                                                                            : 'buynow'
                                                                                    }
                                                                                    key={index}
                                                                                    type={
                                                                                        data.auction
                                                                                            ? 'auction'
                                                                                            : 'buynow'
                                                                                    }
                                                                                    selectedProduct={
                                                                                        selectedProduct
                                                                                    }
                                                                                    link={`/gallery/product-view/${data.id}`}
                                                                                    handleClick={
                                                                                        handleClick
                                                                                    }
                                                                                    timerTheme=""
                                                                                    sliderTheme="multiseller"
                                                                                    cardTheme="liquidationTwo"
                                                                                    bidBtnLabel="Place Bid"
                                                                                    showCondition={
                                                                                        false
                                                                                    }
                                                                                    showLocation={
                                                                                        true
                                                                                    }
                                                                                    timerIcon={true}
                                                                                    bidStatus={true}
                                                                                    setViewProduct={
                                                                                        setViewProduct
                                                                                    }
                                                                                    viewProduct={
                                                                                        viewProduct
                                                                                    }
                                                                                />
                                                                            </div>
                                                                        </SwiperSlide>
                                                                    )
                                                                }
                                                            })}
                                                        </>
                                                    ) : (
                                                        <>
                                                            {viewProduct
                                                                ?.filter(
                                                                    (ele) =>
                                                                        ele.auction == 1 &&
                                                                        ele.buynow == 1,
                                                                )
                                                                ?.map((data, index) => {
                                                                    if (index < 15) {
                                                                        return (
                                                                            <SwiperSlide>
                                                                                <div className="">
                                                                                    <GridProduct
                                                                                        data={data}
                                                                                        className={
                                                                                            data.auction
                                                                                                ? 'auction'
                                                                                                : 'buynow'
                                                                                        }
                                                                                        key={index}
                                                                                        type={
                                                                                            data.auction
                                                                                                ? 'auction'
                                                                                                : 'buynow'
                                                                                        }
                                                                                        selectedProduct={
                                                                                            selectedProduct
                                                                                        }
                                                                                        link={`/gallery/product-view/${data.id}`}
                                                                                        handleClick={
                                                                                            handleClick
                                                                                        }
                                                                                        timerTheme=""
                                                                                        sliderTheme="multiseller"
                                                                                        cardTheme="liquidationTwo"
                                                                                        bidBtnLabel="Place Bid"
                                                                                        showCondition={
                                                                                            false
                                                                                        }
                                                                                        showLocation={
                                                                                            true
                                                                                        }
                                                                                        timerIcon={
                                                                                            true
                                                                                        }
                                                                                        bidStatus={
                                                                                            true
                                                                                        }
                                                                                        setViewProduct={
                                                                                            setViewProduct
                                                                                        }
                                                                                        viewProduct={
                                                                                            viewProduct
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            </SwiperSlide>
                                                                        )
                                                                    }
                                                                })}
                                                        </>
                                                    )}
                                                </>
                                            ) : (
                                                <div
                                                    className={
                                                        checkMediaWithPrimeBidTheme
                                                            ? 'searchContainer gridViewPrimebidsMobile'
                                                            : ''
                                                    }
                                                >
                                                    {viewProduct
                                                        ?.filter((ele) => ele.auction == 1)
                                                        ?.map((data, index) => {
                                                            if (index < 15) {
                                                                return (
                                                                    <>
                                                                        {!checkMediaWithPrimeBidTheme ? (
                                                                            <SwiperSlide>
                                                                                <div className="">
                                                                                    <GridProduct
                                                                                        data={data}
                                                                                        className={
                                                                                            data.auction
                                                                                                ? 'auction'
                                                                                                : 'buynow'
                                                                                        }
                                                                                        key={index}
                                                                                        type={
                                                                                            data.auction
                                                                                                ? 'auction'
                                                                                                : 'buynow'
                                                                                        }
                                                                                        selectedProduct={
                                                                                            selectedProduct
                                                                                        }
                                                                                        link={`/gallery/product-view/${data.id}`}
                                                                                        handleClick={
                                                                                            handleClick
                                                                                        }
                                                                                        timerTheme=""
                                                                                        sliderTheme="multiseller"
                                                                                        cardTheme="liquidationTwo"
                                                                                        bidBtnLabel="Place Bid"
                                                                                        showCondition={
                                                                                            false
                                                                                        }
                                                                                        showLocation={
                                                                                            true
                                                                                        }
                                                                                        timerIcon={
                                                                                            true
                                                                                        }
                                                                                        bidStatus={
                                                                                            true
                                                                                        }
                                                                                        setViewProduct={
                                                                                            setViewProduct
                                                                                        }
                                                                                        viewProduct={
                                                                                            viewProduct
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            </SwiperSlide>
                                                                        ) : (
                                                                            <div className="lotResults mb-4 liquidationBuyCard">
                                                                                <GridProduct
                                                                                    data={data}
                                                                                    className={
                                                                                        data.auction
                                                                                            ? 'auction'
                                                                                            : 'buynow'
                                                                                    }
                                                                                    key={index}
                                                                                    type={
                                                                                        data.auction
                                                                                            ? 'auction'
                                                                                            : 'buynow'
                                                                                    }
                                                                                    selectedProduct={
                                                                                        selectedProduct
                                                                                    }
                                                                                    link={`/gallery/product-view/${data.id}`}
                                                                                    handleClick={
                                                                                        handleClick
                                                                                    }
                                                                                    timerTheme=""
                                                                                    sliderTheme="multiseller"
                                                                                    cardTheme="liquidationTwo"
                                                                                    bidBtnLabel="Place Bid"
                                                                                    showCondition={
                                                                                        false
                                                                                    }
                                                                                    showLocation={
                                                                                        true
                                                                                    }
                                                                                    timerIcon={true}
                                                                                    bidStatus={true}
                                                                                    setViewProduct={
                                                                                        setViewProduct
                                                                                    }
                                                                                    viewProduct={
                                                                                        viewProduct
                                                                                    }
                                                                                />
                                                                            </div>
                                                                        )}
                                                                    </>
                                                                )
                                                            }
                                                        })}
                                                </div>
                                            )}
                                        </Swiper>
                                    </div>
                                    <div className="explrMore text-center mb-1">
                                        <Button
                                            onClick={() =>
                                                handleRedirectInternal(history, `search`)
                                            }
                                        >
                                            Explore
                                        </Button>
                                    </div>
                                </div>
                            )}
                        </>
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <>
                            {loading ? (
                                <div className="homeLoader">
                                    <Loaders
                                        name="product_grid_view"
                                        isLoading={loading}
                                        loop={5}
                                    />
                                </div>
                            ) : viewProduct.filter(
                                  (data) => data.market_status == 'open' && data.remainingDay >= 0,
                              ).length === 0 ? (
                                <NoRecordsFound />
                            ) : (
                                <div>
                                    <div className="mb-2 liquidationBuyCard">
                                        <Swiper
                                            navigation={true}
                                            spaceBetween={13}
                                            speed={2500}
                                            grabCursor={true}
                                            slidesPerView={4}
                                            slidesPerGroup={4}
                                            showsPagination={false}
                                            // pagination={{
                                            //     clickable: false,
                                            // }}
                                            autoplay={{
                                                delay: 2500,
                                                disableOnInteraction: false,
                                                pauseOnMouseEnter: true,
                                            }}
                                            breakpoints={{
                                                300: {
                                                    slidesPerGroup: 1,
                                                    slidesPerView: 1,
                                                },
                                                500: {
                                                    slidesPerView: 2,
                                                },
                                                900: {
                                                    slidesPerView: 3,
                                                },
                                                1260: {
                                                    slidesPerView: 4,
                                                },
                                                1400: {
                                                    slidesPerView: 5,
                                                },
                                            }}
                                            modules={[
                                                Autoplay,
                                                EffectCoverflow,
                                                Navigation,
                                                Pagination,
                                            ]}
                                            className="mySwiper"
                                        >
                                            <div
                                                className={
                                                    checkMediaWithPrimeBidTheme
                                                        ? 'searchContainer gridViewPrimebidsMobile'
                                                        : ''
                                                }
                                            >
                                                {viewProduct
                                                    ?.filter((ele) => ele.auction == 1)
                                                    ?.map((data, index) => {
                                                        if (index < 15) {
                                                            return (
                                                                <>
                                                                    {!checkMediaWithPrimeBidTheme ? (
                                                                        <SwiperSlide>
                                                                            <div>
                                                                                <GridProduct
                                                                                    data={data}
                                                                                    className={
                                                                                        data.auction
                                                                                            ? 'auction'
                                                                                            : 'buynow'
                                                                                    }
                                                                                    key={index}
                                                                                    type={
                                                                                        data.auction
                                                                                            ? 'auction'
                                                                                            : 'buynow'
                                                                                    }
                                                                                    selectedProduct={
                                                                                        selectedProduct
                                                                                    }
                                                                                    link={`/gallery/product-view/${data.id}`}
                                                                                    handleClick={
                                                                                        handleClick
                                                                                    }
                                                                                    timerTheme=""
                                                                                    sliderTheme="multiseller"
                                                                                    cardTheme="liquidationTwo"
                                                                                    bidBtnLabel="Place Bid"
                                                                                    showCondition={
                                                                                        false
                                                                                    }
                                                                                    bidStatus={true}
                                                                                    showLocation={
                                                                                        true
                                                                                    }
                                                                                    timerIcon={true}
                                                                                    setViewProduct={
                                                                                        setViewProduct
                                                                                    }
                                                                                    viewProduct={
                                                                                        viewProduct
                                                                                    }
                                                                                />
                                                                            </div>
                                                                        </SwiperSlide>
                                                                    ) : (
                                                                        <div className="lotResults mb-4 liquidationBuyCard">
                                                                            <GridProduct
                                                                                data={data}
                                                                                className={
                                                                                    data.auction
                                                                                        ? 'auction'
                                                                                        : 'buynow'
                                                                                }
                                                                                key={index}
                                                                                type={
                                                                                    data.auction
                                                                                        ? 'auction'
                                                                                        : 'buynow'
                                                                                }
                                                                                selectedProduct={
                                                                                    selectedProduct
                                                                                }
                                                                                link={`/gallery/product-view/${data.id}`}
                                                                                handleClick={
                                                                                    handleClick
                                                                                }
                                                                                timerTheme=""
                                                                                sliderTheme="multiseller"
                                                                                cardTheme="liquidationTwo"
                                                                                bidBtnLabel="Place Bid"
                                                                                showCondition={
                                                                                    false
                                                                                }
                                                                                bidStatus={true}
                                                                                showLocation={true}
                                                                                timerIcon={true}
                                                                                setViewProduct={
                                                                                    setViewProduct
                                                                                }
                                                                                viewProduct={
                                                                                    viewProduct
                                                                                }
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </>
                                                            )
                                                        }
                                                    })}
                                            </div>
                                        </Swiper>
                                    </div>
                                    <div className="explrMore text-center mb-1">
                                        <Button
                                            onClick={() =>
                                                handleRedirectInternal(history, `search`)
                                            }
                                        >
                                            Explore
                                        </Button>
                                    </div>
                                </div>
                            )}
                        </>
                    </TabPanel>
                    {productLocalState.disableBuynowLocations?.includes(
                        productLocalState.globalLocation,
                    ) || global?.storeConfigration?.home_pag_liq_2_changes?.value ? null : (
                        <TabPanel value={value} index={2}>
                            <>
                                {loading_buynow ? (
                                    <div className="homeLoader">
                                        <Loaders
                                            name="product_grid_view"
                                            isLoading={loading_buynow}
                                            loop={5}
                                        />
                                    </div>
                                ) : buyNowProduct.length === 0 ? (
                                    <NoRecordsFound />
                                ) : (
                                    <div>
                                        <div className="mb-2 liquidationBuyCard">
                                            <Swiper
                                                navigation={true}
                                                spaceBetween={13}
                                                grabCursor={true}
                                                showsPagination={false}
                                                // pagination={{
                                                //     clickable: false,
                                                // }}
                                                speed={2500}
                                                slidesPerView={4}
                                                slidesPerGroup={4}
                                                autoplay={{
                                                    delay: 2500,
                                                    disableOnInteraction: false,
                                                    pauseOnMouseEnter: true,
                                                }}
                                                breakpoints={{
                                                    300: {
                                                        slidesPerGroup: 1,
                                                        slidesPerView: 1,
                                                    },
                                                    500: {
                                                        slidesPerView: 2,
                                                    },
                                                    900: {
                                                        slidesPerView: 3,
                                                    },
                                                    1260: {
                                                        slidesPerView: 4,
                                                    },
                                                    1400: {
                                                        slidesPerView: 5,
                                                    },
                                                }}
                                                modules={[
                                                    Autoplay,
                                                    EffectCoverflow,
                                                    Navigation,
                                                    Pagination,
                                                ]}
                                                className="mySwiper"
                                            >
                                                {buyNowProduct.map((data, index) => {
                                                    if (index < 15) {
                                                        return (
                                                            <SwiperSlide>
                                                                <div>
                                                                    <GridProduct
                                                                        data={data}
                                                                        className={
                                                                            global.storeConfigration
                                                                                ?.liq_home_page_changes
                                                                                ?.value == 1
                                                                                ? 'buynow'
                                                                                : data.auction
                                                                                ? 'auction'
                                                                                : 'buynow'
                                                                        }
                                                                        key={index}
                                                                        type={
                                                                            global.storeConfigration
                                                                                ?.liq_home_page_changes
                                                                                ?.value == 1
                                                                                ? 'buynow'
                                                                                : data.auction
                                                                                ? 'auction'
                                                                                : 'buynow'
                                                                        }
                                                                        selectedProduct={
                                                                            selectedProduct
                                                                        }
                                                                        link={`/gallery/product-view/${data.id}`}
                                                                        handleClick={handleClick}
                                                                        timerTheme=""
                                                                        sliderTheme="multiseller"
                                                                        cardTheme="liquidationTwo"
                                                                        bidBtnLabel="Place Bid"
                                                                        showCondition={false}
                                                                        showLocation={true}
                                                                        timerIcon={true}
                                                                        bidStatus={true}
                                                                        setViewProduct={
                                                                            setViewProduct
                                                                        }
                                                                        viewProduct={viewProduct}
                                                                    />
                                                                </div>
                                                            </SwiperSlide>
                                                        )
                                                    }
                                                })}
                                            </Swiper>
                                        </div>
                                        <div className="explrMore text-center mb-1">
                                            <Button
                                                onClick={() =>
                                                    handleRedirectInternal(history, `search`)
                                                }
                                            >
                                                Explore
                                            </Button>
                                        </div>
                                    </div>
                                )}
                            </>
                        </TabPanel>
                    )}
                    {global?.storeConfigration?.enable_feature_lots?.value == 1 && (
                        <TabPanel value={value} index={3}>
                            <div className="homeCnt">
                                <>
                                    <h2 className="auctionListTitle">Featured Lots</h2>

                                    {loading ? (
                                        <div className="homeLoader">
                                            <Loaders
                                                name="product_grid_view"
                                                isLoading={loading}
                                                loop={5}
                                            />
                                        </div>
                                    ) : viewProduct.filter((data) => data.feature == 1).length ===
                                      0 ? (
                                        <NoRecordsFound />
                                    ) : (
                                        <div>
                                            <div className="mb-2 liquidationBuyCard">
                                                <Swiper
                                                    navigation={true}
                                                    spaceBetween={13}
                                                    grabCursor={true}
                                                    slidesPerView={4}
                                                    slidesPerGroup={4}
                                                    speed={2500}
                                                    showsPagination={false}
                                                    // pagination={{
                                                    //     clickable: false,
                                                    // }}
                                                    autoplay={{
                                                        delay: 2500,
                                                        disableOnInteraction: false,
                                                        pauseOnMouseEnter: true,
                                                    }}
                                                    breakpoints={{
                                                        300: {
                                                            slidesPerGroup: 1,
                                                            slidesPerView: 1,
                                                        },
                                                        500: {
                                                            slidesPerView: 2,
                                                        },
                                                        900: {
                                                            slidesPerView: 3,
                                                        },
                                                        1260: {
                                                            slidesPerView: 4,
                                                        },
                                                        1400: {
                                                            slidesPerView: 5,
                                                        },
                                                    }}
                                                    modules={[
                                                        Autoplay,
                                                        EffectCoverflow,
                                                        Navigation,
                                                        Pagination,
                                                    ]}
                                                    className="mySwiper"
                                                >
                                                    {viewProduct
                                                        ?.filter((ele) => ele.feature == 1)
                                                        ?.map((data, index) => {
                                                            if (index < 15) {
                                                                return (
                                                                    <SwiperSlide>
                                                                        <div className="">
                                                                            <GridProduct
                                                                                data={data}
                                                                                className={
                                                                                    data.auction
                                                                                        ? 'auction'
                                                                                        : 'buynow'
                                                                                }
                                                                                key={index}
                                                                                type={
                                                                                    data.auction
                                                                                        ? 'auction'
                                                                                        : 'buynow'
                                                                                }
                                                                                selectedProduct={
                                                                                    selectedProduct
                                                                                }
                                                                                link={`/gallery/product-view/${data.id}`}
                                                                                handleClick={
                                                                                    handleClick
                                                                                }
                                                                                timerTheme=""
                                                                                sliderTheme="multiseller"
                                                                                cardTheme="liquidationTwo"
                                                                                bidBtnLabel="Place Bid"
                                                                                showCondition={
                                                                                    false
                                                                                }
                                                                                showLocation={true}
                                                                                timerIcon={true}
                                                                                bidStatus={true}
                                                                                setViewProduct={
                                                                                    setViewProduct
                                                                                }
                                                                                viewProduct={
                                                                                    viewProduct
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </SwiperSlide>
                                                                )
                                                            }
                                                        })}
                                                </Swiper>
                                            </div>
                                            <div className="explrMore text-center mb-1">
                                                <Button
                                                    onClick={() =>
                                                        handleRedirectInternal(history, `search`)
                                                    }
                                                >
                                                    Explore
                                                </Button>
                                            </div>
                                        </div>
                                    )}
                                </>
                            </div>
                        </TabPanel>
                    )}
                    {global?.pluginConfiguration?.most_viewed?.enable == 1 && (
                        <TabPanel value={value} index={4}>
                            <div className="homeCnt">
                                <>
                                    <h2 className="auctionListTitle">Most Viewed Lots</h2>

                                    {loading ? (
                                        <div className="homeLoader">
                                            <Loaders
                                                name="product_grid_view"
                                                isLoading={loading}
                                                loop={5}
                                            />
                                        </div>
                                    ) : viewProduct.length === 0 ? (
                                        <NoRecordsFound />
                                    ) : (
                                        <div>
                                            <div className="mb-2 liquidationBuyCard">
                                                <Swiper
                                                    navigation={true}
                                                    spaceBetween={13}
                                                    grabCursor={true}
                                                    slidesPerView={4}
                                                    slidesPerGroup={4}
                                                    speed={2500}
                                                    showsPagination={false}
                                                    // pagination={{
                                                    //     clickable: false,
                                                    // }}
                                                    autoplay={{
                                                        delay: 2500,
                                                        disableOnInteraction: false,
                                                        pauseOnMouseEnter: true,
                                                    }}
                                                    breakpoints={{
                                                        300: {
                                                            slidesPerGroup: 1,
                                                            slidesPerView: 1,
                                                        },
                                                        500: {
                                                            slidesPerView: 2,
                                                        },
                                                        900: {
                                                            slidesPerView: 3,
                                                        },
                                                        1260: {
                                                            slidesPerView: 4,
                                                        },
                                                        1400: {
                                                            slidesPerView: 5,
                                                        },
                                                    }}
                                                    modules={[
                                                        Autoplay,
                                                        EffectCoverflow,
                                                        Navigation,
                                                        Pagination,
                                                    ]}
                                                    className="mySwiper"
                                                >
                                                    {viewProduct?.map((data, index) => {
                                                        if (index < 15) {
                                                            return (
                                                                <SwiperSlide>
                                                                    <div className="">
                                                                        <GridProduct
                                                                            data={data}
                                                                            className={
                                                                                data.auction
                                                                                    ? 'auction'
                                                                                    : 'buynow'
                                                                            }
                                                                            key={index}
                                                                            type={
                                                                                data.auction
                                                                                    ? 'auction'
                                                                                    : 'buynow'
                                                                            }
                                                                            selectedProduct={
                                                                                selectedProduct
                                                                            }
                                                                            link={`/gallery/product-view/${data.id}`}
                                                                            handleClick={
                                                                                handleClick
                                                                            }
                                                                            timerTheme=""
                                                                            sliderTheme="multiseller"
                                                                            cardTheme="liquidationTwo"
                                                                            bidBtnLabel="Place Bid"
                                                                            showCondition={false}
                                                                            showLocation={true}
                                                                            timerIcon={true}
                                                                            bidStatus={true}
                                                                            setViewProduct={
                                                                                setViewProduct
                                                                            }
                                                                            viewProduct={
                                                                                viewProduct
                                                                            }
                                                                        />
                                                                    </div>
                                                                </SwiperSlide>
                                                            )
                                                        }
                                                    })}
                                                </Swiper>
                                            </div>
                                            <div className="explrMore text-center mb-1">
                                                <Button
                                                    onClick={() =>
                                                        handleRedirectInternal(history, `search`)
                                                    }
                                                >
                                                    Explore
                                                </Button>
                                            </div>
                                        </div>
                                    )}
                                </>
                            </div>
                        </TabPanel>
                    )}
                </div>
                {/* {checkThemeClassName && (
                    <div className="customContainer">
                        <div className="PmHiwBase-root">
                            <div className="PmHiwVideoDetails-root">
                                <h4>How PrimeBids Works</h4>
                                <ul>
                                    <li>All Auction Started at Just $1</li>
                                </ul>
                                <a href="#">Read Our FAQ&apos;s to Learn More</a>
                            </div>
                            <div className="PmHiwVideo-root">
                                <video src=""></video>
                            </div>
                        </div>
                    </div>
                )} */}
                <div className="hiwContainer">
                    <h2 className="divHdrTxt text-center">What we do</h2>
                    {/* <p className="hdrInfoTxt text-center">
                            You can buy products at incredible prices on{' '}
                            {global?.storeDetails?.name} in just 3 steps
                        </p> */}
                    {/* {bodyClass ? (
                            <div className="hiwSteps pbHiwSteps">
                                <div className="hiwStpCard">
                                    <div className="hiwIcnWrp">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="131.03"
                                            height="131.035"
                                            viewBox="0 0 131.03 131.035"
                                        >
                                            <path
                                                id="Union_1"
                                                data-name="Union 1"
                                                d="M38.9,131.035a1.883,1.883,0,0,1-1.338-.557,1.905,1.905,0,0,1-.554-1.331v-4.765a6.76,6.76,0,0,1,1.639-4.476,5.64,5.64,0,0,1,4.279-1.978h1.821L48.893,104.1H5.938a5.675,5.675,0,0,1-4.281-2A6.787,6.787,0,0,1,0,97.6V6.52A6.866,6.866,0,0,1,1.669,2.013,5.707,5.707,0,0,1,5.548.024V.005h.4L6.347,0V.005H125.083a5.686,5.686,0,0,1,4.28,2.011,6.78,6.78,0,0,1,1.656,4.507V82.617a1.9,1.9,0,0,1,0,.421V97.6a6.781,6.781,0,0,1-1.659,4.505,5.67,5.67,0,0,1-4.274,2H82.13l4.115,13.824H88.07a5.664,5.664,0,0,1,4.28,1.978,6.763,6.763,0,0,1,1.637,4.479l0,.4h-.027v4.362a1.891,1.891,0,0,1-1.889,1.891Zm2.626-8.646,0,0a2.978,2.978,0,0,0-.7,1.981v2.878H90.206v-2.47H90.2l.006-.507a3.023,3.023,0,0,0-.7-1.884,1.859,1.859,0,0,0-1.407-.681H42.932A1.855,1.855,0,0,0,41.528,122.388Zm7.17-4.461H82.3L78.142,104.1H52.888Zm30.893-17.606h45.487a1.928,1.928,0,0,0,1.445-.7l0,0a3.024,3.024,0,0,0,.719-2.011V84.72H3.783V97.607A3.024,3.024,0,0,0,4.5,99.617l.005.006a1.893,1.893,0,0,0,1.443.7H79.591ZM5.955,3.788a1.949,1.949,0,0,0-1.451.7,3.08,3.08,0,0,0-.722,2.025V80.938H127.247V6.513a3.048,3.048,0,0,0-.72-2.011l0,0a1.933,1.933,0,0,0-1.445-.708l-119.084,0ZM57.332,94.55a1.891,1.891,0,1,1,0-3.782H73.7a1.891,1.891,0,0,1,0,3.782ZM30.989,56.1a1.473,1.473,0,0,1-.768-1,1.374,1.374,0,0,1,.23-1.123,1.489,1.489,0,0,1,1.3-.776,1.34,1.34,0,0,1,.817.27L65.266,72.236,98.006,53.348a1.7,1.7,0,0,1,.755-.179,1.54,1.54,0,0,1,1.326.72l.014.027A1.592,1.592,0,0,1,99.56,56l-.005,0L65.266,75.886Zm12.062-6.647V25.224a1.549,1.549,0,0,1-.1-.541,1.474,1.474,0,0,1,.787-1.323,1.352,1.352,0,0,1,.122-.07L64.5,11.372a1.646,1.646,0,0,1,1.526,0l.021.011L86.472,23.176a1.494,1.494,0,0,1,1.1,1.367c0,.047.006.093.006.14,0,.017,0,.035,0,.053v24.72L65.265,62.349Zm3.136-1.727L65.265,58.7,84.441,47.632V27.363L66.834,37.528V52.538a1.57,1.57,0,0,1-3.136-.1v-15L46.187,27.406ZM47.66,24.683,65.266,34.837,82.872,24.683,65.266,14.53ZM97,47.279a1.764,1.764,0,1,1,1.764,1.763A1.766,1.766,0,0,1,97,47.279Zm-67,0a1.764,1.764,0,1,1,1.764,1.763A1.766,1.766,0,0,1,30,47.279ZM97,41.63a1.764,1.764,0,1,1,1.764,1.763A1.766,1.766,0,0,1,97,41.63Zm-67,0a1.764,1.764,0,1,1,1.764,1.763A1.766,1.766,0,0,1,30,41.63Zm67-5.648a1.764,1.764,0,1,1,1.764,1.763A1.766,1.766,0,0,1,97,35.981Zm-67,0a1.764,1.764,0,1,1,1.764,1.763A1.766,1.766,0,0,1,30,35.981Zm67-5.649A1.764,1.764,0,1,1,98.769,32.1,1.766,1.766,0,0,1,97,30.332Zm-67,0A1.764,1.764,0,1,1,31.764,32.1,1.766,1.766,0,0,1,30,30.332Zm67-5.551a1.764,1.764,0,1,1,1.764,1.764A1.766,1.766,0,0,1,97,24.781Zm-67,0a1.764,1.764,0,1,1,1.764,1.764A1.766,1.766,0,0,1,30,24.781Z"
                                                transform="translate(-0.001)"
                                            />
                                        </svg>
                                    </div>
                                    <div className="hiwTxtBdy">
                                        <h4>Explore & Secure</h4>
                                        <p>
                                            Dive into our daily auctions to uncover your prized
                                            possessions.
                                        </p>
                                    </div>
                                </div>
                                <div className="hiwStpCard">
                                    <div className="hiwIcnWrp">
                                        <svg
                                            id="Group_4"
                                            data-name="Group 4"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="87.903"
                                            height="130.629"
                                            viewBox="0 0 87.903 130.629"
                                        >
                                            <path
                                                id="Path_20"
                                                data-name="Path 20"
                                                d="M262.082,111.561h-5.8a18.933,18.933,0,0,1-17.591-11.812,12.554,12.554,0,0,0-11.667-7.838h-11.55V81h26.075a9.49,9.49,0,0,0,9.476-9.476V31.047a9.488,9.488,0,0,0-9.476-9.476H185.576a9.49,9.49,0,0,0-9.476,9.476v40.48A9.488,9.488,0,0,0,185.576,81h26.075V92.134a8.868,8.868,0,0,0-6.947,8.645v5.074a7.212,7.212,0,0,0-4.473,12.513,7.187,7.187,0,0,0,.038,10.639,7.187,7.187,0,0,0-.038,10.639,7.233,7.233,0,0,0,4.9,12.555h28.218a26.257,26.257,0,0,0,10.724-2.271l1.575-.7a16.537,16.537,0,0,1,6.761-1.428h9.68A1.916,1.916,0,0,0,264,145.889V113.481a1.926,1.926,0,0,0-1.919-1.92ZM179.931,71.525V31.048a5.651,5.651,0,0,1,5.643-5.643h55.978a5.648,5.648,0,0,1,5.64,5.643v40.48a5.649,5.649,0,0,1-5.64,5.643H185.574a5.653,5.653,0,0,1-5.644-5.647ZM204.7,109.731v4.733a7.878,7.878,0,0,0,.271,1.952,3.354,3.354,0,0,1-.271-6.685Zm-2.972,13.953a3.405,3.405,0,0,1,3.4-3.4h2.143a7.847,7.847,0,0,0,10.766,0H222a3.4,3.4,0,0,1,0,6.806H205.125a3.4,3.4,0,0,1-3.4-3.4Zm18.6-7.233c.053-.206.107-.41.141-.622.126.206.242.422.374.622ZM222,130.919a3.4,3.4,0,0,1,0,6.806H205.124a3.4,3.4,0,0,1,0-6.806Zm-20.277,14.038a3.405,3.405,0,0,1,3.4-3.4H222a3.4,3.4,0,0,1,0,6.806H205.125A3.407,3.407,0,0,1,201.725,144.957Zm58.44-1H252.4a20.3,20.3,0,0,0-8.314,1.763l-1.572.7a22.442,22.442,0,0,1-9.17,1.94h-5a7.085,7.085,0,0,0,.89-3.4,7.2,7.2,0,0,0-2.37-5.322,7.154,7.154,0,0,0,0-10.639,7.208,7.208,0,0,0,2.2-3.777,35.645,35.645,0,0,0,12.537,6.151,1.75,1.75,0,0,0,.49.062,1.917,1.917,0,0,0,.487-3.771A31.793,31.793,0,0,1,220.6,107.354v-.84a1.915,1.915,0,1,0-3.829,0v7.946a4.117,4.117,0,0,1-8.235,0V100.77a5.04,5.04,0,0,1,5.033-5.033h13.46a8.737,8.737,0,0,1,8.123,5.454,22.745,22.745,0,0,0,21.135,14.195h3.88Z"
                                                transform="translate(-176.1 -21.57)"
                                            />
                                            <path
                                                id="Path_21"
                                                data-name="Path 21"
                                                d="M312.049,124.945v-8.722a1.916,1.916,0,0,0-1.916-1.916h-8.725a1.916,1.916,0,0,0-1.913,1.916v8.722a1.916,1.916,0,0,0,1.913,1.916h8.722a1.916,1.916,0,0,0,1.919-1.916Zm-3.833-1.916h-4.892v-4.889h4.892Z"
                                                transform="translate(-268.309 -90.869)"
                                            />
                                            <path
                                                id="Path_22"
                                                data-name="Path 22"
                                                d="M370.443,126.869h8.722a1.916,1.916,0,0,0,1.916-1.916V116.23a1.916,1.916,0,0,0-1.916-1.916h-8.722a1.916,1.916,0,0,0-1.913,1.916v8.722A1.916,1.916,0,0,0,370.443,126.869Zm1.919-8.722h4.889v4.889h-4.889Z"
                                                transform="translate(-319.896 -90.875)"
                                            />
                                            <path
                                                id="Path_23"
                                                data-name="Path 23"
                                                d="M241.105,114.31H232.38a1.916,1.916,0,0,0-1.913,1.916v8.722a1.916,1.916,0,0,0,1.913,1.916H241.1a1.916,1.916,0,0,0,1.916-1.916v-8.722a1.908,1.908,0,0,0-1.913-1.916Zm-1.914,8.722H234.3v-4.889h4.892Z"
                                                transform="translate(-216.726 -90.871)"
                                            />
                                        </svg>
                                    </div>
                                    <div className="hiwTxtBdy">
                                        <h4>Bid & Capture</h4>
                                        <p>
                                            Stake your claim and acquire your desired items within a
                                            week.
                                        </p>
                                    </div>
                                </div>
                                <div className="hiwStpCard">
                                    <div className="hiwIcnWrp">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="131.683"
                                            height="131.129"
                                            viewBox="0 0 131.683 131.129"
                                        >
                                            <g
                                                id="noun-home-delivery-4326793"
                                                transform="translate(0.251 0.25)"
                                            >
                                                <path
                                                    id="Path_24"
                                                    data-name="Path 24"
                                                    d="M308.416,378.7a1.7,1.7,0,1,0,1.7,1.7A1.706,1.706,0,0,0,308.416,378.7Z"
                                                    transform="translate(-251.478 -289.771)"
                                                />
                                                <path
                                                    id="Path_24_-_Outline"
                                                    data-name="Path 24 - Outline"
                                                    d="M308.416,378.45a1.953,1.953,0,1,1-1.953,1.953A1.955,1.955,0,0,1,308.416,378.45Zm0,3.406a1.453,1.453,0,1,0-1.453-1.453A1.454,1.454,0,0,0,308.416,381.856Z"
                                                    transform="translate(-251.478 -289.771)"
                                                />
                                                <path
                                                    id="Path_25"
                                                    data-name="Path 25"
                                                    d="M206.46,58.128c-6.107-4.527-13.984-10.394-22.095-16.44V16.823h3.126a1.4,1.4,0,0,0,1.4-1.4V12.871A5.848,5.848,0,0,0,183.08,7H165.049a5.872,5.872,0,0,0-5.867,5.862v2.568a1.4,1.4,0,0,0,1.4,1.4h3.188V26.38l-21.5-16.032a1.391,1.391,0,0,0-1.669,0L76.4,58.132a1.4,1.4,0,0,0,.837,2.512h11.89a1.394,1.394,0,0,0,.832-.279l4.583-3.411V99.42a1.4,1.4,0,0,0,2.791,0V55.566h32.377V59.25a1.4,1.4,0,0,0,1.4,1.4h20.655a1.4,1.4,0,0,0,1.4-1.4V55.566h32.377V93.8H170.519a1.43,1.43,0,0,0-.792.246l-12.281,8.435c-.039.028-.039.084-.073.111a1.253,1.253,0,0,0-.279.43,1.291,1.291,0,0,0-.2.48c-.006.05-.05.079-.05.122v9.6H139.928V80.574A16.468,16.468,0,0,0,123.46,64.106h-.006a16.468,16.468,0,0,0-16.462,16.469v32.657H97.334V108.18a1.4,1.4,0,1,0-2.791,0v5.052H86.28a1.4,1.4,0,0,0-1.4,1.4v9.044a1.4,1.4,0,0,0,1.4,1.4h70.561v11.165a1.4,1.4,0,0,0,1.4,1.4h32.547a1.458,1.458,0,0,0,.8-.246l12.281-8.49c.034-.022.028-.067.056-.09a2.986,2.986,0,0,0,.492-.938c.006-.045.05-.073.05-.122V95.2c0-.15-.117-.251-.162-.385s0-.285-.084-.407c-.028-.039-.084-.039-.111-.073a1.209,1.209,0,0,0-.447-.285,1.3,1.3,0,0,0-.458-.19c-.05-.006-.079-.056-.128-.056H188.328V56.96l4.578,3.411a1.407,1.407,0,0,0,.832.279h11.89a1.4,1.4,0,0,0,.832-2.523ZM170.951,96.6h27.616l-8.218,5.644H162.733ZM201.67,127.01l-9.49,6.56v-29.2l9.49-6.515Zm-29.363-21.984h4.41v4.628l-1.262-1.106a1.4,1.4,0,0,0-1.831-.006l-1.318,1.139ZM113.792,70.9a13.556,13.556,0,0,1,9.663-4h.006A13.548,13.548,0,0,1,137,79.184h-27.08a13.54,13.54,0,0,1,3.874-8.284Zm-4.008,11.07h27.353v31.262H109.784Zm-22.106,40.3v-6.252h20.577c.05.006.079.056.134.056s.084-.05.134-.056H138.4c.05.006.078.056.134.056s.084-.05.134-.056h18.176v6.252Zm101.711,12.56H159.634v-29.81h9.887v7.7a1.4,1.4,0,0,0,.815,1.273,1.416,1.416,0,0,0,1.5-.212l2.707-2.339,2.663,2.334a1.42,1.42,0,0,0,.921.346,1.536,1.536,0,0,0,.58-.122,1.4,1.4,0,0,0,.815-1.273v-7.7H189.4v29.805ZM161.978,12.858a3.076,3.076,0,0,1,3.076-3.07H183.08a3.046,3.046,0,0,1,3.015,3.07V14.03H161.979ZM150.366,39.989v7.536H142.83V39.989ZM140.04,47.525H132.5V39.989h7.536ZM132.5,50.317h7.536v7.536H132.5Zm17.863,7.536H142.83V50.317h7.536Zm2.792-5.08V38.594a1.4,1.4,0,0,0-1.4-1.4H131.108a1.4,1.4,0,0,0-1.4,1.4V52.773H100.153l41.282-30.748,41.282,30.748Zm41.048,5.08L142.267,19.162a1.416,1.416,0,0,0-1.669,0L88.665,57.853H81.447L141.436,13.2,164.33,30.281c.558.413,1.748,1.367,2.97,2.334,1.323,1.05,2.674,2.127,3.3,2.591a1.4,1.4,0,1,0,1.658-2.25c-.608-.452-1.926-1.5-3.216-2.529-.971-.776-1.836-1.457-2.478-1.954V16.823h15.017V39.61L179.6,38.136a1.4,1.4,0,0,0-1.669,2.239l4.209,3.137c6.877,5.125,13.61,10.138,19.271,14.341Z"
                                                    transform="translate(-75.844 -6.998)"
                                                />
                                                <path
                                                    id="Path_25_-_Outline"
                                                    data-name="Path 25 - Outline"
                                                    d="M165.049,6.748H183.08a6.1,6.1,0,0,1,6.056,6.125v2.555a1.647,1.647,0,0,1-1.645,1.645h-2.876V41.563c7.79,5.807,15.837,11.8,21.993,16.364h0a1.65,1.65,0,0,1-.98,2.975h-11.89a1.658,1.658,0,0,1-.981-.329l-4.178-3.114v36.1h14.494a.345.345,0,0,1,.194.062,1.191,1.191,0,0,1,.407.158c.032.017.064.035.1.052l.089.043a1.207,1.207,0,0,1,.412.276.358.358,0,0,1,.148.117.7.7,0,0,1,.108.376.633.633,0,0,0,.011.1.643.643,0,0,0,.049.091.7.7,0,0,1,.124.369v32.54a.353.353,0,0,1-.057.188,1.262,1.262,0,0,1-.17.436c-.016.029-.032.058-.048.088l-.042.086a1.3,1.3,0,0,1-.279.421.317.317,0,0,1-.115.139l-12.282,8.491a1.7,1.7,0,0,1-.935.287H158.237a1.647,1.647,0,0,1-1.645-1.645V125.317H86.28a1.647,1.647,0,0,1-1.645-1.645v-9.044a1.647,1.647,0,0,1,1.645-1.645h8.013v-4.8a1.645,1.645,0,1,1,3.291,0v4.8h9.158V80.575a16.718,16.718,0,0,1,16.712-16.719h.006a16.718,16.718,0,0,1,16.718,16.718v32.407h16.415V103.63a.341.341,0,0,1,.056-.182,1.2,1.2,0,0,1,.171-.44c.018-.031.035-.063.053-.1l.042-.084a1.251,1.251,0,0,1,.269-.4.359.359,0,0,1,.118-.149l12.285-8.438a1.682,1.682,0,0,1,.934-.29h14.767V55.816H153.409V59.25a1.647,1.647,0,0,1-1.645,1.645H131.108a1.647,1.647,0,0,1-1.645-1.645V55.816H97.585v43.6a1.645,1.645,0,0,1-3.291,0V57.451L90.11,60.565a1.635,1.635,0,0,1-.981.329H77.239a1.646,1.646,0,0,1-.986-2.963l64.2-47.785a1.651,1.651,0,0,1,.989-.328,1.606,1.606,0,0,1,.98.329l21.1,15.733V17.073h-2.938a1.647,1.647,0,0,1-1.645-1.645V12.86A6.121,6.121,0,0,1,165.049,6.748Zm22.442,9.825a1.147,1.147,0,0,0,1.145-1.145V12.871a5.6,5.6,0,0,0-5.558-5.623H165.049a5.621,5.621,0,0,0-5.617,5.612v2.568a1.147,1.147,0,0,0,1.145,1.145h3.438V26.878l-21.9-16.33a1.112,1.112,0,0,0-.68-.229,1.154,1.154,0,0,0-.691.229L76.55,58.333a1.146,1.146,0,0,0,.688,2.062h11.89a1.139,1.139,0,0,0,.683-.23l4.982-3.708V99.42a1.145,1.145,0,0,0,2.291,0v-44.1h32.877V59.25a1.147,1.147,0,0,0,1.145,1.145h20.655a1.147,1.147,0,0,0,1.145-1.145V55.316h32.877V94.055H170.519a1.181,1.181,0,0,0-.654.2l-12.239,8.407a.344.344,0,0,1-.1.126.755.755,0,0,0-.167.257c-.015.031-.031.062-.047.094s-.04.074-.06.11a.725.725,0,0,0-.113.277.374.374,0,0,1-.049.149v9.8H139.678V80.574A16.218,16.218,0,0,0,123.46,64.356h-.006a16.218,16.218,0,0,0-16.212,16.219v32.907H97.084v-5.3a1.145,1.145,0,1,0-2.291,0v5.3H86.28a1.147,1.147,0,0,0-1.145,1.145v9.044a1.147,1.147,0,0,0,1.145,1.145h70.811v11.415a1.147,1.147,0,0,0,1.145,1.145h32.547a1.2,1.2,0,0,0,.658-.2l12.235-8.458a.312.312,0,0,1,.082-.106.811.811,0,0,0,.186-.287c.015-.032.031-.064.047-.1s.037-.07.055-.1a.766.766,0,0,0,.115-.284v-.008a.351.351,0,0,1,.049-.137V95.2a.329.329,0,0,0-.053-.112.963.963,0,0,1-.1-.193l0-.009a.944.944,0,0,1-.032-.216.837.837,0,0,0-.009-.09.336.336,0,0,1-.11-.088.724.724,0,0,0-.265-.17l-.1-.048c-.039-.02-.076-.04-.113-.06a.7.7,0,0,0-.257-.1.366.366,0,0,1-.155-.055H188.078V56.462l4.977,3.709a1.154,1.154,0,0,0,.682.23h11.89a1.15,1.15,0,0,0,.684-2.072l.008-.011-.009.011c-6.182-4.583-14.273-10.61-22.1-16.44l-.1-.075V16.573ZM165.054,9.538H183.08a3.3,3.3,0,0,1,3.265,3.322v1.42H161.729V12.858A3.327,3.327,0,0,1,165.054,9.538Zm20.791,4.242v-.922a2.8,2.8,0,0,0-2.767-2.82H165.054a2.826,2.826,0,0,0-2.826,2.82v.922Zm-44.408-.887,23.043,17.188c.417.309,1.174.91,2.051,1.605l.925.733.572.454c1.126.894,2.189,1.738,2.721,2.132a1.159,1.159,0,0,0,.687.224,1.111,1.111,0,0,0,.915-.465,1.144,1.144,0,0,0-.241-1.607c-.611-.454-1.933-1.507-3.211-2.525l-.013-.01c-.917-.733-1.8-1.426-2.476-1.952l-.1-.075V16.573h15.517V40.108l-2.376-1.772a1.124,1.124,0,0,0-.683-.229,1.148,1.148,0,0,0-.687,2.067l4.209,3.137c8.214,6.121,14.337,10.678,19.27,14.34l.607.451h-8.047l-52-38.741a1.143,1.143,0,0,0-.683-.222,1.162,1.162,0,0,0-.689.224l-52,38.739H80.693Zm30,22.835a1.657,1.657,0,0,1-.983-.321c-.54-.4-1.606-1.247-2.736-2.143l-.571-.453-.925-.733c-.873-.693-1.627-1.291-2.038-1.6L141.436,13.517,82.2,57.6h6.38l51.867-38.642a1.661,1.661,0,0,1,.986-.321,1.64,1.64,0,0,1,.981.321L194.288,57.6h6.369c-4.827-3.585-10.783-8.017-18.664-13.89l-4.209-3.137a1.648,1.648,0,0,1,.986-2.968,1.619,1.619,0,0,1,.983.329l1.576,1.175V17.073H166.813V28.349c.667.517,1.508,1.182,2.384,1.881l.012.01c1.275,1.015,2.593,2.065,3.2,2.514a1.648,1.648,0,0,1-.971,2.974Zm-30-14.015,42.036,31.31H152.908V38.594a1.147,1.147,0,0,0-1.145-1.145H131.108a1.147,1.147,0,0,0-1.145,1.145V53.023H99.4Zm40.528,30.81L141.435,22.337,100.907,52.523h28.555V38.594a1.647,1.647,0,0,1,1.645-1.645h20.655a1.647,1.647,0,0,1,1.645,1.645V52.523Zm-49.71-12.784h8.036v8.036h-8.036Zm7.536.5h-7.036v7.036h7.036Zm2.791-.5h8.036v8.036H142.58Zm7.536.5H143.08v7.036h7.036Zm-17.863,9.828h8.036V58.1h-8.036Zm7.536.5h-7.036V57.6h7.036Zm2.791-.5h8.036V58.1H142.58Zm7.536.5H143.08V57.6h7.036Zm-26.661,16.08h.006a13.8,13.8,0,0,1,13.787,12.511l.028.275H109.642l.028-.275a13.75,13.75,0,0,1,3.744-8.23l0,0,.2-.2A13.805,13.805,0,0,1,123.455,66.647ZM136.72,78.934a13.185,13.185,0,0,0-3.766-7.851,13.319,13.319,0,0,0-9.492-3.935h-.006A13.307,13.307,0,0,0,114.042,71l-.073.073a13.213,13.213,0,0,0-3.771,7.857ZM109.534,81.72h27.853v31.762H109.534Zm27.353.5H110.034v30.762h26.853Zm33.986,14.127h28.5l-8.946,6.144h-28.5Zm26.888.5H171.028l-7.49,5.144h26.733Zm4.159.531v29.763l-9.99,6.905V104.235Zm-.5,29.5V98.327l-8.99,6.171v28.594Zm-42.036-22.1H169.77v7.954a1.155,1.155,0,0,0,.666,1.044,1.241,1.241,0,0,0,.488.1,1.12,1.12,0,0,0,.743-.274l2.872-2.481,2.826,2.477a1.175,1.175,0,0,0,.757.284,1.286,1.286,0,0,0,.482-.1,1.143,1.143,0,0,0,.664-1.043v-7.954h10.381v30.327l-.271-.022H159.384Zm9.887.5h-9.387v29.31h29.266v-29.3h-9.381v7.454a1.644,1.644,0,0,1-.962,1.5l-.008,0a1.784,1.784,0,0,1-.675.141,1.678,1.678,0,0,1-1.083-.405l-2.5-2.193-2.543,2.2a1.635,1.635,0,0,1-1.07.4,1.74,1.74,0,0,1-.688-.143l-.006,0a1.656,1.656,0,0,1-.96-1.5Zm2.787-.5h4.91v5.429l-1.676-1.469a1.155,1.155,0,0,0-1.5,0l-1.73,1.5Zm4.41.5h-3.91v3.859l.9-.782a1.655,1.655,0,0,1,2.157,0l.849.744Zm-89.04,10.5,20.855,0a.2.2,0,0,0,.212,0l.028,0,29.91,0a.2.2,0,0,0,.212,0l.028,0H157.1v6.752H87.428Zm20.772.5H87.928v5.752H156.6v-5.752h-17.87a.347.347,0,0,1-.378,0H108.578a.347.347,0,0,1-.378,0Z"
                                                    transform="translate(-75.844 -6.998)"
                                                />
                                                <path
                                                    id="Path_26"
                                                    data-name="Path 26"
                                                    d="M445.826,497.46h-9.267a1.4,1.4,0,0,0-1.4,1.4v5.521a1.4,1.4,0,0,0,1.4,1.4h9.262a1.4,1.4,0,0,0,1.4-1.4v-5.52a1.4,1.4,0,0,0-1.39-1.4Zm-1.4,5.527h-6.475v-2.736h6.47v2.736Z"
                                                    transform="translate(-349.198 -380.118)"
                                                />
                                                <path
                                                    id="Path_26_-_Outline"
                                                    data-name="Path 26 - Outline"
                                                    d="M436.559,497.21h9.267a1.645,1.645,0,0,1,1.64,1.648v5.519a1.647,1.647,0,0,1-1.645,1.645h-9.262a1.647,1.647,0,0,1-1.645-1.645v-5.521A1.647,1.647,0,0,1,436.559,497.21Zm9.262,8.312a1.147,1.147,0,0,0,1.145-1.145v-5.52a1.145,1.145,0,0,0-1.14-1.146h-9.267a1.147,1.147,0,0,0-1.145,1.145v5.521a1.147,1.147,0,0,0,1.145,1.145ZM437.7,500h6.97v2.986h-.245v.25H437.7Zm6.47.5H438.2v2.236h5.97Z"
                                                    transform="translate(-349.198 -380.118)"
                                                />
                                            </g>
                                        </svg>
                                    </div>
                                    <div className="hiwTxtBdy">
                                        <h4>Seamless Pickup</h4>
                                        <p>
                                            Effortlessly retrieve your winnings at our designated
                                            spot.
                                        </p>
                                    </div>
                                </div>
                                <div className="hiwStpCard">
                                    <div className="hiwIcnWrp">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 -960 960 960"
                                            width="131.683"
                                            height="131.129"
                                        >
                                            <path d="M295.384-80V-358.23L158.461-580l160.385-260h322.308l160.385 260-136.923 221.769V-80L480-143.846 295.384-80Zm40.001-58.692L480-187.077l144.615 48.385V-320h-289.23v181.308ZM340.769-800l-136 220 136 220h278.462l136-220-136-220H340.769ZM438-445.461 324.461-558 353-586.539l85 85 169-170L635.539-644 438-445.461ZM335.385-320h289.23-289.23Z" />
                                        </svg>
                                    </div>
                                    <div className="hiwTxtBdy">
                                        <h4>Guaranteed Delight</h4>
                                        <p>
                                            Enjoy hassle-free returns within seven days for a
                                            contented experience.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="hiwSteps">
                                <div className="hiwStpCard">
                                    <div className="hiwIcnWrp">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="131.03"
                                            height="131.035"
                                            viewBox="0 0 131.03 131.035"
                                        >
                                            <path
                                                id="Union_1"
                                                data-name="Union 1"
                                                d="M38.9,131.035a1.883,1.883,0,0,1-1.338-.557,1.905,1.905,0,0,1-.554-1.331v-4.765a6.76,6.76,0,0,1,1.639-4.476,5.64,5.64,0,0,1,4.279-1.978h1.821L48.893,104.1H5.938a5.675,5.675,0,0,1-4.281-2A6.787,6.787,0,0,1,0,97.6V6.52A6.866,6.866,0,0,1,1.669,2.013,5.707,5.707,0,0,1,5.548.024V.005h.4L6.347,0V.005H125.083a5.686,5.686,0,0,1,4.28,2.011,6.78,6.78,0,0,1,1.656,4.507V82.617a1.9,1.9,0,0,1,0,.421V97.6a6.781,6.781,0,0,1-1.659,4.505,5.67,5.67,0,0,1-4.274,2H82.13l4.115,13.824H88.07a5.664,5.664,0,0,1,4.28,1.978,6.763,6.763,0,0,1,1.637,4.479l0,.4h-.027v4.362a1.891,1.891,0,0,1-1.889,1.891Zm2.626-8.646,0,0a2.978,2.978,0,0,0-.7,1.981v2.878H90.206v-2.47H90.2l.006-.507a3.023,3.023,0,0,0-.7-1.884,1.859,1.859,0,0,0-1.407-.681H42.932A1.855,1.855,0,0,0,41.528,122.388Zm7.17-4.461H82.3L78.142,104.1H52.888Zm30.893-17.606h45.487a1.928,1.928,0,0,0,1.445-.7l0,0a3.024,3.024,0,0,0,.719-2.011V84.72H3.783V97.607A3.024,3.024,0,0,0,4.5,99.617l.005.006a1.893,1.893,0,0,0,1.443.7H79.591ZM5.955,3.788a1.949,1.949,0,0,0-1.451.7,3.08,3.08,0,0,0-.722,2.025V80.938H127.247V6.513a3.048,3.048,0,0,0-.72-2.011l0,0a1.933,1.933,0,0,0-1.445-.708l-119.084,0ZM57.332,94.55a1.891,1.891,0,1,1,0-3.782H73.7a1.891,1.891,0,0,1,0,3.782ZM30.989,56.1a1.473,1.473,0,0,1-.768-1,1.374,1.374,0,0,1,.23-1.123,1.489,1.489,0,0,1,1.3-.776,1.34,1.34,0,0,1,.817.27L65.266,72.236,98.006,53.348a1.7,1.7,0,0,1,.755-.179,1.54,1.54,0,0,1,1.326.72l.014.027A1.592,1.592,0,0,1,99.56,56l-.005,0L65.266,75.886Zm12.062-6.647V25.224a1.549,1.549,0,0,1-.1-.541,1.474,1.474,0,0,1,.787-1.323,1.352,1.352,0,0,1,.122-.07L64.5,11.372a1.646,1.646,0,0,1,1.526,0l.021.011L86.472,23.176a1.494,1.494,0,0,1,1.1,1.367c0,.047.006.093.006.14,0,.017,0,.035,0,.053v24.72L65.265,62.349Zm3.136-1.727L65.265,58.7,84.441,47.632V27.363L66.834,37.528V52.538a1.57,1.57,0,0,1-3.136-.1v-15L46.187,27.406ZM47.66,24.683,65.266,34.837,82.872,24.683,65.266,14.53ZM97,47.279a1.764,1.764,0,1,1,1.764,1.763A1.766,1.766,0,0,1,97,47.279Zm-67,0a1.764,1.764,0,1,1,1.764,1.763A1.766,1.766,0,0,1,30,47.279ZM97,41.63a1.764,1.764,0,1,1,1.764,1.763A1.766,1.766,0,0,1,97,41.63Zm-67,0a1.764,1.764,0,1,1,1.764,1.763A1.766,1.766,0,0,1,30,41.63Zm67-5.648a1.764,1.764,0,1,1,1.764,1.763A1.766,1.766,0,0,1,97,35.981Zm-67,0a1.764,1.764,0,1,1,1.764,1.763A1.766,1.766,0,0,1,30,35.981Zm67-5.649A1.764,1.764,0,1,1,98.769,32.1,1.766,1.766,0,0,1,97,30.332Zm-67,0A1.764,1.764,0,1,1,31.764,32.1,1.766,1.766,0,0,1,30,30.332Zm67-5.551a1.764,1.764,0,1,1,1.764,1.764A1.766,1.766,0,0,1,97,24.781Zm-67,0a1.764,1.764,0,1,1,1.764,1.764A1.766,1.766,0,0,1,30,24.781Z"
                                                transform="translate(-0.001)"
                                            />
                                        </svg>
                                    </div>
                                    <div className="hiwTxtBdy">
                                        <h4>1.Browse our catalog</h4>
                                        <p>{global?.storeConfigration?.hiw_first?.value}</p>
                                    </div>
                                </div>
                                <div className="hiwStpCard">
                                    <div className="hiwIcnWrp">
                                        <svg
                                            id="Group_4"
                                            data-name="Group 4"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="87.903"
                                            height="130.629"
                                            viewBox="0 0 87.903 130.629"
                                        >
                                            <path
                                                id="Path_20"
                                                data-name="Path 20"
                                                d="M262.082,111.561h-5.8a18.933,18.933,0,0,1-17.591-11.812,12.554,12.554,0,0,0-11.667-7.838h-11.55V81h26.075a9.49,9.49,0,0,0,9.476-9.476V31.047a9.488,9.488,0,0,0-9.476-9.476H185.576a9.49,9.49,0,0,0-9.476,9.476v40.48A9.488,9.488,0,0,0,185.576,81h26.075V92.134a8.868,8.868,0,0,0-6.947,8.645v5.074a7.212,7.212,0,0,0-4.473,12.513,7.187,7.187,0,0,0,.038,10.639,7.187,7.187,0,0,0-.038,10.639,7.233,7.233,0,0,0,4.9,12.555h28.218a26.257,26.257,0,0,0,10.724-2.271l1.575-.7a16.537,16.537,0,0,1,6.761-1.428h9.68A1.916,1.916,0,0,0,264,145.889V113.481a1.926,1.926,0,0,0-1.919-1.92ZM179.931,71.525V31.048a5.651,5.651,0,0,1,5.643-5.643h55.978a5.648,5.648,0,0,1,5.64,5.643v40.48a5.649,5.649,0,0,1-5.64,5.643H185.574a5.653,5.653,0,0,1-5.644-5.647ZM204.7,109.731v4.733a7.878,7.878,0,0,0,.271,1.952,3.354,3.354,0,0,1-.271-6.685Zm-2.972,13.953a3.405,3.405,0,0,1,3.4-3.4h2.143a7.847,7.847,0,0,0,10.766,0H222a3.4,3.4,0,0,1,0,6.806H205.125a3.4,3.4,0,0,1-3.4-3.4Zm18.6-7.233c.053-.206.107-.41.141-.622.126.206.242.422.374.622ZM222,130.919a3.4,3.4,0,0,1,0,6.806H205.124a3.4,3.4,0,0,1,0-6.806Zm-20.277,14.038a3.405,3.405,0,0,1,3.4-3.4H222a3.4,3.4,0,0,1,0,6.806H205.125A3.407,3.407,0,0,1,201.725,144.957Zm58.44-1H252.4a20.3,20.3,0,0,0-8.314,1.763l-1.572.7a22.442,22.442,0,0,1-9.17,1.94h-5a7.085,7.085,0,0,0,.89-3.4,7.2,7.2,0,0,0-2.37-5.322,7.154,7.154,0,0,0,0-10.639,7.208,7.208,0,0,0,2.2-3.777,35.645,35.645,0,0,0,12.537,6.151,1.75,1.75,0,0,0,.49.062,1.917,1.917,0,0,0,.487-3.771A31.793,31.793,0,0,1,220.6,107.354v-.84a1.915,1.915,0,1,0-3.829,0v7.946a4.117,4.117,0,0,1-8.235,0V100.77a5.04,5.04,0,0,1,5.033-5.033h13.46a8.737,8.737,0,0,1,8.123,5.454,22.745,22.745,0,0,0,21.135,14.195h3.88Z"
                                                transform="translate(-176.1 -21.57)"
                                            />
                                            <path
                                                id="Path_21"
                                                data-name="Path 21"
                                                d="M312.049,124.945v-8.722a1.916,1.916,0,0,0-1.916-1.916h-8.725a1.916,1.916,0,0,0-1.913,1.916v8.722a1.916,1.916,0,0,0,1.913,1.916h8.722a1.916,1.916,0,0,0,1.919-1.916Zm-3.833-1.916h-4.892v-4.889h4.892Z"
                                                transform="translate(-268.309 -90.869)"
                                            />
                                            <path
                                                id="Path_22"
                                                data-name="Path 22"
                                                d="M370.443,126.869h8.722a1.916,1.916,0,0,0,1.916-1.916V116.23a1.916,1.916,0,0,0-1.916-1.916h-8.722a1.916,1.916,0,0,0-1.913,1.916v8.722A1.916,1.916,0,0,0,370.443,126.869Zm1.919-8.722h4.889v4.889h-4.889Z"
                                                transform="translate(-319.896 -90.875)"
                                            />
                                            <path
                                                id="Path_23"
                                                data-name="Path 23"
                                                d="M241.105,114.31H232.38a1.916,1.916,0,0,0-1.913,1.916v8.722a1.916,1.916,0,0,0,1.913,1.916H241.1a1.916,1.916,0,0,0,1.916-1.916v-8.722a1.908,1.908,0,0,0-1.913-1.916Zm-1.914,8.722H234.3v-4.889h4.892Z"
                                                transform="translate(-216.726 -90.871)"
                                            />
                                        </svg>
                                    </div>
                                    <div className="hiwTxtBdy">
                                        <h4>2.Bid for bargains</h4>
                                        <p>{global?.storeConfigration?.hiw_second?.value}</p>
                                    </div>
                                </div>
                                <div className="hiwStpCard">
                                    <div className="hiwIcnWrp">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="131.683"
                                            height="131.129"
                                            viewBox="0 0 131.683 131.129"
                                        >
                                            <g
                                                id="noun-home-delivery-4326793"
                                                transform="translate(0.251 0.25)"
                                            >
                                                <path
                                                    id="Path_24"
                                                    data-name="Path 24"
                                                    d="M308.416,378.7a1.7,1.7,0,1,0,1.7,1.7A1.706,1.706,0,0,0,308.416,378.7Z"
                                                    transform="translate(-251.478 -289.771)"
                                                />
                                                <path
                                                    id="Path_24_-_Outline"
                                                    data-name="Path 24 - Outline"
                                                    d="M308.416,378.45a1.953,1.953,0,1,1-1.953,1.953A1.955,1.955,0,0,1,308.416,378.45Zm0,3.406a1.453,1.453,0,1,0-1.453-1.453A1.454,1.454,0,0,0,308.416,381.856Z"
                                                    transform="translate(-251.478 -289.771)"
                                                />
                                                <path
                                                    id="Path_25"
                                                    data-name="Path 25"
                                                    d="M206.46,58.128c-6.107-4.527-13.984-10.394-22.095-16.44V16.823h3.126a1.4,1.4,0,0,0,1.4-1.4V12.871A5.848,5.848,0,0,0,183.08,7H165.049a5.872,5.872,0,0,0-5.867,5.862v2.568a1.4,1.4,0,0,0,1.4,1.4h3.188V26.38l-21.5-16.032a1.391,1.391,0,0,0-1.669,0L76.4,58.132a1.4,1.4,0,0,0,.837,2.512h11.89a1.394,1.394,0,0,0,.832-.279l4.583-3.411V99.42a1.4,1.4,0,0,0,2.791,0V55.566h32.377V59.25a1.4,1.4,0,0,0,1.4,1.4h20.655a1.4,1.4,0,0,0,1.4-1.4V55.566h32.377V93.8H170.519a1.43,1.43,0,0,0-.792.246l-12.281,8.435c-.039.028-.039.084-.073.111a1.253,1.253,0,0,0-.279.43,1.291,1.291,0,0,0-.2.48c-.006.05-.05.079-.05.122v9.6H139.928V80.574A16.468,16.468,0,0,0,123.46,64.106h-.006a16.468,16.468,0,0,0-16.462,16.469v32.657H97.334V108.18a1.4,1.4,0,1,0-2.791,0v5.052H86.28a1.4,1.4,0,0,0-1.4,1.4v9.044a1.4,1.4,0,0,0,1.4,1.4h70.561v11.165a1.4,1.4,0,0,0,1.4,1.4h32.547a1.458,1.458,0,0,0,.8-.246l12.281-8.49c.034-.022.028-.067.056-.09a2.986,2.986,0,0,0,.492-.938c.006-.045.05-.073.05-.122V95.2c0-.15-.117-.251-.162-.385s0-.285-.084-.407c-.028-.039-.084-.039-.111-.073a1.209,1.209,0,0,0-.447-.285,1.3,1.3,0,0,0-.458-.19c-.05-.006-.079-.056-.128-.056H188.328V56.96l4.578,3.411a1.407,1.407,0,0,0,.832.279h11.89a1.4,1.4,0,0,0,.832-2.523ZM170.951,96.6h27.616l-8.218,5.644H162.733ZM201.67,127.01l-9.49,6.56v-29.2l9.49-6.515Zm-29.363-21.984h4.41v4.628l-1.262-1.106a1.4,1.4,0,0,0-1.831-.006l-1.318,1.139ZM113.792,70.9a13.556,13.556,0,0,1,9.663-4h.006A13.548,13.548,0,0,1,137,79.184h-27.08a13.54,13.54,0,0,1,3.874-8.284Zm-4.008,11.07h27.353v31.262H109.784Zm-22.106,40.3v-6.252h20.577c.05.006.079.056.134.056s.084-.05.134-.056H138.4c.05.006.078.056.134.056s.084-.05.134-.056h18.176v6.252Zm101.711,12.56H159.634v-29.81h9.887v7.7a1.4,1.4,0,0,0,.815,1.273,1.416,1.416,0,0,0,1.5-.212l2.707-2.339,2.663,2.334a1.42,1.42,0,0,0,.921.346,1.536,1.536,0,0,0,.58-.122,1.4,1.4,0,0,0,.815-1.273v-7.7H189.4v29.805ZM161.978,12.858a3.076,3.076,0,0,1,3.076-3.07H183.08a3.046,3.046,0,0,1,3.015,3.07V14.03H161.979ZM150.366,39.989v7.536H142.83V39.989ZM140.04,47.525H132.5V39.989h7.536ZM132.5,50.317h7.536v7.536H132.5Zm17.863,7.536H142.83V50.317h7.536Zm2.792-5.08V38.594a1.4,1.4,0,0,0-1.4-1.4H131.108a1.4,1.4,0,0,0-1.4,1.4V52.773H100.153l41.282-30.748,41.282,30.748Zm41.048,5.08L142.267,19.162a1.416,1.416,0,0,0-1.669,0L88.665,57.853H81.447L141.436,13.2,164.33,30.281c.558.413,1.748,1.367,2.97,2.334,1.323,1.05,2.674,2.127,3.3,2.591a1.4,1.4,0,1,0,1.658-2.25c-.608-.452-1.926-1.5-3.216-2.529-.971-.776-1.836-1.457-2.478-1.954V16.823h15.017V39.61L179.6,38.136a1.4,1.4,0,0,0-1.669,2.239l4.209,3.137c6.877,5.125,13.61,10.138,19.271,14.341Z"
                                                    transform="translate(-75.844 -6.998)"
                                                />
                                                <path
                                                    id="Path_25_-_Outline"
                                                    data-name="Path 25 - Outline"
                                                    d="M165.049,6.748H183.08a6.1,6.1,0,0,1,6.056,6.125v2.555a1.647,1.647,0,0,1-1.645,1.645h-2.876V41.563c7.79,5.807,15.837,11.8,21.993,16.364h0a1.65,1.65,0,0,1-.98,2.975h-11.89a1.658,1.658,0,0,1-.981-.329l-4.178-3.114v36.1h14.494a.345.345,0,0,1,.194.062,1.191,1.191,0,0,1,.407.158c.032.017.064.035.1.052l.089.043a1.207,1.207,0,0,1,.412.276.358.358,0,0,1,.148.117.7.7,0,0,1,.108.376.633.633,0,0,0,.011.1.643.643,0,0,0,.049.091.7.7,0,0,1,.124.369v32.54a.353.353,0,0,1-.057.188,1.262,1.262,0,0,1-.17.436c-.016.029-.032.058-.048.088l-.042.086a1.3,1.3,0,0,1-.279.421.317.317,0,0,1-.115.139l-12.282,8.491a1.7,1.7,0,0,1-.935.287H158.237a1.647,1.647,0,0,1-1.645-1.645V125.317H86.28a1.647,1.647,0,0,1-1.645-1.645v-9.044a1.647,1.647,0,0,1,1.645-1.645h8.013v-4.8a1.645,1.645,0,1,1,3.291,0v4.8h9.158V80.575a16.718,16.718,0,0,1,16.712-16.719h.006a16.718,16.718,0,0,1,16.718,16.718v32.407h16.415V103.63a.341.341,0,0,1,.056-.182,1.2,1.2,0,0,1,.171-.44c.018-.031.035-.063.053-.1l.042-.084a1.251,1.251,0,0,1,.269-.4.359.359,0,0,1,.118-.149l12.285-8.438a1.682,1.682,0,0,1,.934-.29h14.767V55.816H153.409V59.25a1.647,1.647,0,0,1-1.645,1.645H131.108a1.647,1.647,0,0,1-1.645-1.645V55.816H97.585v43.6a1.645,1.645,0,0,1-3.291,0V57.451L90.11,60.565a1.635,1.635,0,0,1-.981.329H77.239a1.646,1.646,0,0,1-.986-2.963l64.2-47.785a1.651,1.651,0,0,1,.989-.328,1.606,1.606,0,0,1,.98.329l21.1,15.733V17.073h-2.938a1.647,1.647,0,0,1-1.645-1.645V12.86A6.121,6.121,0,0,1,165.049,6.748Zm22.442,9.825a1.147,1.147,0,0,0,1.145-1.145V12.871a5.6,5.6,0,0,0-5.558-5.623H165.049a5.621,5.621,0,0,0-5.617,5.612v2.568a1.147,1.147,0,0,0,1.145,1.145h3.438V26.878l-21.9-16.33a1.112,1.112,0,0,0-.68-.229,1.154,1.154,0,0,0-.691.229L76.55,58.333a1.146,1.146,0,0,0,.688,2.062h11.89a1.139,1.139,0,0,0,.683-.23l4.982-3.708V99.42a1.145,1.145,0,0,0,2.291,0v-44.1h32.877V59.25a1.147,1.147,0,0,0,1.145,1.145h20.655a1.147,1.147,0,0,0,1.145-1.145V55.316h32.877V94.055H170.519a1.181,1.181,0,0,0-.654.2l-12.239,8.407a.344.344,0,0,1-.1.126.755.755,0,0,0-.167.257c-.015.031-.031.062-.047.094s-.04.074-.06.11a.725.725,0,0,0-.113.277.374.374,0,0,1-.049.149v9.8H139.678V80.574A16.218,16.218,0,0,0,123.46,64.356h-.006a16.218,16.218,0,0,0-16.212,16.219v32.907H97.084v-5.3a1.145,1.145,0,1,0-2.291,0v5.3H86.28a1.147,1.147,0,0,0-1.145,1.145v9.044a1.147,1.147,0,0,0,1.145,1.145h70.811v11.415a1.147,1.147,0,0,0,1.145,1.145h32.547a1.2,1.2,0,0,0,.658-.2l12.235-8.458a.312.312,0,0,1,.082-.106.811.811,0,0,0,.186-.287c.015-.032.031-.064.047-.1s.037-.07.055-.1a.766.766,0,0,0,.115-.284v-.008a.351.351,0,0,1,.049-.137V95.2a.329.329,0,0,0-.053-.112.963.963,0,0,1-.1-.193l0-.009a.944.944,0,0,1-.032-.216.837.837,0,0,0-.009-.09.336.336,0,0,1-.11-.088.724.724,0,0,0-.265-.17l-.1-.048c-.039-.02-.076-.04-.113-.06a.7.7,0,0,0-.257-.1.366.366,0,0,1-.155-.055H188.078V56.462l4.977,3.709a1.154,1.154,0,0,0,.682.23h11.89a1.15,1.15,0,0,0,.684-2.072l.008-.011-.009.011c-6.182-4.583-14.273-10.61-22.1-16.44l-.1-.075V16.573ZM165.054,9.538H183.08a3.3,3.3,0,0,1,3.265,3.322v1.42H161.729V12.858A3.327,3.327,0,0,1,165.054,9.538Zm20.791,4.242v-.922a2.8,2.8,0,0,0-2.767-2.82H165.054a2.826,2.826,0,0,0-2.826,2.82v.922Zm-44.408-.887,23.043,17.188c.417.309,1.174.91,2.051,1.605l.925.733.572.454c1.126.894,2.189,1.738,2.721,2.132a1.159,1.159,0,0,0,.687.224,1.111,1.111,0,0,0,.915-.465,1.144,1.144,0,0,0-.241-1.607c-.611-.454-1.933-1.507-3.211-2.525l-.013-.01c-.917-.733-1.8-1.426-2.476-1.952l-.1-.075V16.573h15.517V40.108l-2.376-1.772a1.124,1.124,0,0,0-.683-.229,1.148,1.148,0,0,0-.687,2.067l4.209,3.137c8.214,6.121,14.337,10.678,19.27,14.34l.607.451h-8.047l-52-38.741a1.143,1.143,0,0,0-.683-.222,1.162,1.162,0,0,0-.689.224l-52,38.739H80.693Zm30,22.835a1.657,1.657,0,0,1-.983-.321c-.54-.4-1.606-1.247-2.736-2.143l-.571-.453-.925-.733c-.873-.693-1.627-1.291-2.038-1.6L141.436,13.517,82.2,57.6h6.38l51.867-38.642a1.661,1.661,0,0,1,.986-.321,1.64,1.64,0,0,1,.981.321L194.288,57.6h6.369c-4.827-3.585-10.783-8.017-18.664-13.89l-4.209-3.137a1.648,1.648,0,0,1,.986-2.968,1.619,1.619,0,0,1,.983.329l1.576,1.175V17.073H166.813V28.349c.667.517,1.508,1.182,2.384,1.881l.012.01c1.275,1.015,2.593,2.065,3.2,2.514a1.648,1.648,0,0,1-.971,2.974Zm-30-14.015,42.036,31.31H152.908V38.594a1.147,1.147,0,0,0-1.145-1.145H131.108a1.147,1.147,0,0,0-1.145,1.145V53.023H99.4Zm40.528,30.81L141.435,22.337,100.907,52.523h28.555V38.594a1.647,1.647,0,0,1,1.645-1.645h20.655a1.647,1.647,0,0,1,1.645,1.645V52.523Zm-49.71-12.784h8.036v8.036h-8.036Zm7.536.5h-7.036v7.036h7.036Zm2.791-.5h8.036v8.036H142.58Zm7.536.5H143.08v7.036h7.036Zm-17.863,9.828h8.036V58.1h-8.036Zm7.536.5h-7.036V57.6h7.036Zm2.791-.5h8.036V58.1H142.58Zm7.536.5H143.08V57.6h7.036Zm-26.661,16.08h.006a13.8,13.8,0,0,1,13.787,12.511l.028.275H109.642l.028-.275a13.75,13.75,0,0,1,3.744-8.23l0,0,.2-.2A13.805,13.805,0,0,1,123.455,66.647ZM136.72,78.934a13.185,13.185,0,0,0-3.766-7.851,13.319,13.319,0,0,0-9.492-3.935h-.006A13.307,13.307,0,0,0,114.042,71l-.073.073a13.213,13.213,0,0,0-3.771,7.857ZM109.534,81.72h27.853v31.762H109.534Zm27.353.5H110.034v30.762h26.853Zm33.986,14.127h28.5l-8.946,6.144h-28.5Zm26.888.5H171.028l-7.49,5.144h26.733Zm4.159.531v29.763l-9.99,6.905V104.235Zm-.5,29.5V98.327l-8.99,6.171v28.594Zm-42.036-22.1H169.77v7.954a1.155,1.155,0,0,0,.666,1.044,1.241,1.241,0,0,0,.488.1,1.12,1.12,0,0,0,.743-.274l2.872-2.481,2.826,2.477a1.175,1.175,0,0,0,.757.284,1.286,1.286,0,0,0,.482-.1,1.143,1.143,0,0,0,.664-1.043v-7.954h10.381v30.327l-.271-.022H159.384Zm9.887.5h-9.387v29.31h29.266v-29.3h-9.381v7.454a1.644,1.644,0,0,1-.962,1.5l-.008,0a1.784,1.784,0,0,1-.675.141,1.678,1.678,0,0,1-1.083-.405l-2.5-2.193-2.543,2.2a1.635,1.635,0,0,1-1.07.4,1.74,1.74,0,0,1-.688-.143l-.006,0a1.656,1.656,0,0,1-.96-1.5Zm2.787-.5h4.91v5.429l-1.676-1.469a1.155,1.155,0,0,0-1.5,0l-1.73,1.5Zm4.41.5h-3.91v3.859l.9-.782a1.655,1.655,0,0,1,2.157,0l.849.744Zm-89.04,10.5,20.855,0a.2.2,0,0,0,.212,0l.028,0,29.91,0a.2.2,0,0,0,.212,0l.028,0H157.1v6.752H87.428Zm20.772.5H87.928v5.752H156.6v-5.752h-17.87a.347.347,0,0,1-.378,0H108.578a.347.347,0,0,1-.378,0Z"
                                                    transform="translate(-75.844 -6.998)"
                                                />
                                                <path
                                                    id="Path_26"
                                                    data-name="Path 26"
                                                    d="M445.826,497.46h-9.267a1.4,1.4,0,0,0-1.4,1.4v5.521a1.4,1.4,0,0,0,1.4,1.4h9.262a1.4,1.4,0,0,0,1.4-1.4v-5.52a1.4,1.4,0,0,0-1.39-1.4Zm-1.4,5.527h-6.475v-2.736h6.47v2.736Z"
                                                    transform="translate(-349.198 -380.118)"
                                                />
                                                <path
                                                    id="Path_26_-_Outline"
                                                    data-name="Path 26 - Outline"
                                                    d="M436.559,497.21h9.267a1.645,1.645,0,0,1,1.64,1.648v5.519a1.647,1.647,0,0,1-1.645,1.645h-9.262a1.647,1.647,0,0,1-1.645-1.645v-5.521A1.647,1.647,0,0,1,436.559,497.21Zm9.262,8.312a1.147,1.147,0,0,0,1.145-1.145v-5.52a1.145,1.145,0,0,0-1.14-1.146h-9.267a1.147,1.147,0,0,0-1.145,1.145v5.521a1.147,1.147,0,0,0,1.145,1.145ZM437.7,500h6.97v2.986h-.245v.25H437.7Zm6.47.5H438.2v2.236h5.97Z"
                                                    transform="translate(-349.198 -380.118)"
                                                />
                                            </g>
                                        </svg>
                                    </div>
                                    <div className="hiwTxtBdy">
                                        <h4>3.Collect your winnings</h4>
                                        <p>{global?.storeConfigration?.hiw_third?.value}</p>
                                    </div>
                                </div>
                            </div>
                        )} */}
                    <div className="customContainer whtWeDo">
                        <div className="PmHiwBase-root">
                            <div className="PmHiwVideoDetails-root">
                                <ul>
                                    <li>
                                        At PRIME BIDS we buy returned and overstocked goods from top
                                        retailers and sell them in online auctions.
                                    </li>
                                    <li>All auctions start at just $1.</li>
                                    <li>We have over 10,000 winners each WEEK.</li>
                                    <li>
                                        Did you win? Schedule a pick up appointment so your items
                                        are ready to go.
                                    </li>
                                    <li>
                                        Learn how to Bid, Win & Save up to 80% off retail prices in
                                        this video also visit our
                                        <NavLink activeClassName="active" to="/how_it_works">
                                            {' '}
                                            How it works
                                        </NavLink>{' '}
                                        for more details
                                    </li>
                                </ul>
                                {/* <a href="#">Read Our FAQ&apos;s to Learn More</a> */}
                            </div>
                            <div className="PmHiwVideo-root">
                                <video width={350} height={320} controls>
                                    <source
                                        src="/assets/video/demoPrimebids.mp4"
                                        type="video/mp4"
                                    ></source>
                                </video>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="splEvntsWrpr">
                    <div className="customContainer pb-4">
                        <h2 className="divHdrTxt text-center">SPECIAL EVENTS</h2>
                        <div className="vwActnWrapper">
                            {viewAuction.length ? (
                                <div className="hmActnLstWrpr">
                                    {viewAuction.map((data, index) => (
                                        <MultisellerListCard
                                            data={data}
                                            key={index}
                                            details={`search/product-buyer-auction/${data.id}`}
                                            card_theme="liquidationTwo"
                                        />
                                    ))}
                                </div>
                            ) : (
                                <NoRecordsFound />
                            )}
                        </div>
                    </div>
                </div>
                {console.log(global, 'global?.storeDetails')}
                {global?.storeConfigration?.fact_to_know?.value == 0 ? null : (
                    <>
                        {' '}
                        {global?.storeDetails?.fact_to_know ? (
                            <div className="faqContainer">
                                <div className="customContainer py-4">
                                    <h2 className="divHdrTxt">
                                        Facts to know{' '}
                                        <Link to="/faq" className="extnlLnk cursorDecoy">
                                            VIEW FAQS
                                        </Link>
                                    </h2>
                                    <div className="fqLst">
                                        {' '}
                                        {ReactHtmlParser(global.storeDetails.fact_to_know)}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="faqContainer">
                                <div className="customContainer py-4">
                                    <h2 className="divHdrTxt">
                                        Facts to know{' '}
                                        <Link to="/faq" className="extnlLnk cursorDecoy">
                                            VIEW FAQS
                                        </Link>
                                    </h2>
                                    <div className="fqLst">
                                        <ul>
                                            <li>Most items have a starting bid of $5</li>
                                            <li>
                                                Prices increase by our bid increments as bids are
                                                placed
                                            </li>
                                            <li>
                                                We’ll notify you via text and/or email if you’ve
                                                been outbid
                                            </li>
                                            <li>
                                                Credit cards are charged automatically for any
                                                winnings at the end of the auction
                                            </li>
                                        </ul>
                                        <ul>
                                            <li>You have 7 days for local pickup item retrieval</li>
                                            <li>
                                                We offer Refunds, please view our Policy for more
                                                details
                                            </li>
                                            <li>An 11% Buyer’s Premium applies to all sales</li>
                                            <li>
                                                We collect Sales Tax unless you provide a valid
                                                California Resale License
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        )}
                        {global?.storeConfigration?.subscribe?.value && (
                            <div className="homeContact">
                                <h2>Get the latest deals</h2>
                                <p>Subscribe us to get latest updates</p>
                                <div className="subsBox">
                                    <input
                                        type="text"
                                        name="q"
                                        value={inpData}
                                        placeholder="Enter email address"
                                        onChange={(e) => {
                                            setinpData(e.target.value)
                                        }}
                                    />
                                    <Button>
                                        <span className="material-icons" onClick={subscribe}>
                                            send
                                        </span>
                                    </Button>
                                </div>
                            </div>
                        )}
                    </>
                )}
            </div>
            <MultisellerSlider
                selectedLot={selectedProduct}
                handleClose={handleClose}
                currency="cad"
                type={props.type ? props.type : ''}
                storeTheme="Liquidation_two"
                pvTabList={true}
            />
        </Layout>
    )
}

export default Home
